import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AccessUserPayload = {
  __typename?: 'AccessUserPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
};

export type ActiveRedemptionsInput = {
  code: Scalars['String']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
};

export type ActiveRedemptionsPayload = {
  __typename?: 'ActiveRedemptionsPayload';
  data?: Maybe<Array<Maybe<StripeCustomer>>>;
  has_more?: Maybe<Scalars['Boolean']['output']>;
  next_page?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AddFcmTokenInput = {
  platform: PlatFormType;
  token: Scalars['String']['input'];
};

export type AddOrUpdateSecurityPin = {
  securityPin: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AdminRegisterUserInput = {
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AdminUpdatePayload = {
  __typename?: 'AdminUpdatePayload';
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ApiList = {
  __typename?: 'ApiList';
  data: Array<SubscriptionDto>;
  has_more?: Maybe<Scalars['Boolean']['output']>;
  url: Scalars['String']['output'];
};

export type AppliesTo = {
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppliesToProducts = {
  __typename?: 'AppliesToProducts';
  products: Array<Scalars['String']['output']>;
};

export type AutomaticTax = {
  __typename?: 'AutomaticTax';
  enabled: Scalars['Boolean']['output'];
};

export type BillingThresholds = {
  __typename?: 'BillingThresholds';
  amount_gte: Scalars['Float']['output'];
  reset_billing_cycle_anchor?: Maybe<Scalars['Boolean']['output']>;
};

export type CancellationDetails = {
  __typename?: 'CancellationDetails';
  comment?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type Card = {
  __typename?: 'Card';
  address_city?: Maybe<Scalars['String']['output']>;
  address_country?: Maybe<Scalars['String']['output']>;
  address_line1?: Maybe<Scalars['String']['output']>;
  address_line1_check?: Maybe<Scalars['String']['output']>;
  address_line2?: Maybe<Scalars['String']['output']>;
  address_state?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  address_zip_check?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  exp_month?: Maybe<Scalars['Float']['output']>;
  exp_year?: Maybe<Scalars['Float']['output']>;
  last4: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ChangeCardInput = {
  customerStripeId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type Charge = {
  __typename?: 'Charge';
  amount?: Maybe<Scalars['Int']['output']>;
  created: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  failure_code?: Maybe<Scalars['String']['output']>;
  failure_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  object: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
  payment_method_details?: Maybe<PaymentMethodDetails>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  receipt_url?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Card>;
  status: Scalars['String']['output'];
};

export type ConfirmWalletPaymentInput = {
  paymentIntentId: Scalars['String']['input'];
};

export type Contact = {
  __typename?: 'Contact';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  declinedCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nickName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneType: PhoneType;
  priority: Scalars['Int']['output'];
  status?: Maybe<ContactStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactOptInInput = {
  optIn: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type ContactOptInLinkInput = {
  contactId: Scalars['String']['input'];
};

export enum ContactStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED'
}

export type Coupon = {
  __typename?: 'Coupon';
  amount_off?: Maybe<Scalars['Float']['output']>;
  applies_to?: Maybe<AppliesToProducts>;
  created: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  duration: Scalars['String']['output'];
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  livemode: Scalars['Boolean']['output'];
  max_redemptions?: Maybe<Scalars['Float']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  percent_off?: Maybe<Scalars['Float']['output']>;
  redeem_by?: Maybe<Scalars['Float']['output']>;
  times_redeemed: Scalars['Float']['output'];
  valid: Scalars['Boolean']['output'];
};

export type CouponListInput = {
  ending_before?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  starting_after?: InputMaybe<Scalars['String']['input']>;
};

export type CouponPayload = {
  __typename?: 'CouponPayload';
  amountOff?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CouponsListPayload = {
  __typename?: 'CouponsListPayload';
  data: Array<Coupon>;
  has_more?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateClientSecretPayload = {
  __typename?: 'CreateClientSecretPayload';
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type CreateContactInput = {
  contactLimit: Scalars['Float']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nickName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  phoneType?: PhoneType;
};

export type CreateCouponInput = {
  amount_off?: InputMaybe<Scalars['Int']['input']>;
  applies_to?: InputMaybe<AppliesTo>;
  currency?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Duration>;
  duration_in_months?: InputMaybe<Scalars['Float']['input']>;
  expand?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  max_redemptions?: InputMaybe<Scalars['Float']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percent_off?: InputMaybe<Scalars['Float']['input']>;
  redeem_by?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateSocialSourceInput = {
  name: Scalars['String']['input'];
};

export type CreateSubscriptionInput = {
  coupon?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['String']['input'];
  referrerUserId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type DateFilter = {
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type DeleteContactInput = {
  contactLimit: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
};

export type DeleteUserInput = {
  userId: Scalars['String']['input'];
};

export type Discount = {
  __typename?: 'Discount';
  checkout_session?: Maybe<Scalars['String']['output']>;
  coupon: Coupon;
  id: Scalars['String']['output'];
  object: Scalars['String']['output'];
  start: Scalars['Float']['output'];
};

export type EndBehavior = {
  __typename?: 'EndBehavior';
  missing_payment_method: Scalars['String']['output'];
};

export type Feature = {
  __typename?: 'Feature';
  name: Scalars['String']['output'];
};

export type FetchRecentCallLogInput = {
  timeStamp: Scalars['String']['input'];
};

export type FetchRingMyPhoneLogInput = {
  id: Scalars['String']['input'];
};

export type FetchUserByEmailInput = {
  email: Scalars['String']['input'];
};

export type FetchUsersInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderByName?: InputMaybe<Scalars['Boolean']['input']>;
  paginationOptions: PaginationInput;
  roleType: Array<UserRoles>;
  status?: InputMaybe<Scalars['Float']['input']>;
  subscriptionFilters?: InputMaybe<SubscriptionFiltersInput>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type ForgotPasswordInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  loginType?: InputMaybe<LoginType>;
};

export type InviteUserInput = {
  email: Scalars['String']['input'];
  roleType: UserRoles;
};

export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  email: Scalars['String']['output'];
  roleType?: Maybe<UserRoles>;
};

export type Invoice = {
  __typename?: 'Invoice';
  account_country: Scalars['String']['output'];
  account_name: Scalars['String']['output'];
  amount_due: Scalars['Float']['output'];
  amount_paid: Scalars['Float']['output'];
  amount_remaining: Scalars['Float']['output'];
  attempt_count: Scalars['Float']['output'];
  billing_reason?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Charge>;
  created: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
  period_end?: Maybe<Scalars['Float']['output']>;
  period_start?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotal_excluding_tax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_amounts?: Maybe<Array<TotalDiscountAmount>>;
};

export type InvoiceData = {
  __typename?: 'InvoiceData';
  data?: Maybe<Array<Maybe<Invoice>>>;
  has_more: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type InvoiceInput = {
  customer: Scalars['String']['input'];
  ending_before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  starting_after?: InputMaybe<Scalars['String']['input']>;
};

export type IsSubscribed = {
  __typename?: 'IsSubscribed';
  customerStripeId?: Maybe<Scalars['String']['output']>;
  subscriptionCancelled?: Maybe<Scalars['Boolean']['output']>;
};

export enum LoginType {
  Admin = 'ADMIN',
  Portal = 'PORTAL'
}

export type LoginUserInput = {
  email: Scalars['String']['input'];
  loginType?: InputMaybe<LoginType>;
  password: Scalars['String']['input'];
  rememberMe?: Scalars['Boolean']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addFcmToken: Scalars['String']['output'];
  addSecurityPin: Scalars['Boolean']['output'];
  adminRegister: User;
  adminUpdateCustomerEmail: User;
  changeCard: Card;
  confirmWalletPayment: ConfirmWalletPaymentPayload;
  consumeMobileHandoffToken: AccessUserPayload;
  contactOpt: Scalars['String']['output'];
  createClientSecret: CreateClientSecretPayload;
  createContact: Contact;
  createCoupon: Scalars['Boolean']['output'];
  createSocialSource: SocialSource;
  createSubscription: SubscriptionEntity;
  deactivateUserAccount: User;
  deleteContact: Array<Contact>;
  deleteCoupon: Scalars['Boolean']['output'];
  deleteUser: Scalars['String']['output'];
  forgotPassword: Scalars['Boolean']['output'];
  generateMobileHandoffToken: Scalars['String']['output'];
  inviteUser: Scalars['Boolean']['output'];
  login: AccessUserPayload;
  optOutContact: OptOutPayload;
  register: User;
  removeFcmToken: Scalars['String']['output'];
  removeSocialSource: Scalars['Boolean']['output'];
  removeUser: Scalars['Boolean']['output'];
  resendOptInLink: Scalars['String']['output'];
  resendVerificationEmail: Scalars['Boolean']['output'];
  sendOtp: SendOtpPayload;
  sendOtpV2: SendOtpPayload;
  superAdminUpdateAdmin: AdminUpdatePayload;
  swapContactPriority: Array<Contact>;
  updateCardDetail: Card;
  updateContact: Contact;
  updateCoupon: Scalars['Boolean']['output'];
  updateFreePlan: UpdatePlanPayload;
  updateNotificationStatus: Scalars['String']['output'];
  updateSocialSource: SocialSource;
  updateSubscriptionPlan: SubscriptionDto;
  updateUser: User;
  updateUserPassword: User;
  updateUserSocialSource: UserSocialSource;
  updateUserStatusFromAdmin: User;
  userRingMyPhoneSettings: Scalars['String']['output'];
  verifyEmailToken: InviteUserPayload;
  verifyInvitationEmailToken: Scalars['Boolean']['output'];
  verifyOtp: VerifyOtpPayload;
  verifyResetPasswordToken: Scalars['Boolean']['output'];
  verifyResetPasswordTokenAndSetPassword: Scalars['Boolean']['output'];
};


export type MutationAddFcmTokenArgs = {
  addFcmTokenInput: AddFcmTokenInput;
};


export type MutationAddSecurityPinArgs = {
  addOrUpdateSecurityPinInput: AddOrUpdateSecurityPin;
};


export type MutationAdminRegisterArgs = {
  registerAdminUserInput: AdminRegisterUserInput;
};


export type MutationAdminUpdateCustomerEmailArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationChangeCardArgs = {
  changeCardInput: ChangeCardInput;
};


export type MutationConfirmWalletPaymentArgs = {
  confirmWalletPaymentInput: ConfirmWalletPaymentInput;
};


export type MutationConsumeMobileHandoffTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationContactOptArgs = {
  input: ContactOptInInput;
};


export type MutationCreateClientSecretArgs = {
  createSubscriptionInput: CreateSubscriptionInput;
};


export type MutationCreateContactArgs = {
  createContactInput: CreateContactInput;
};


export type MutationCreateCouponArgs = {
  createCouponInput: CreateCouponInput;
};


export type MutationCreateSocialSourceArgs = {
  createSocialSourceInput: CreateSocialSourceInput;
};


export type MutationCreateSubscriptionArgs = {
  createSubscriptionInput: CreateSubscriptionInput;
};


export type MutationDeleteContactArgs = {
  deleteContactInput: DeleteContactInput;
};


export type MutationDeleteCouponArgs = {
  deleteCouponInput: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  deleteUserInput: DeleteUserInput;
};


export type MutationForgotPasswordArgs = {
  forgotPasswordInput: ForgotPasswordInput;
};


export type MutationInviteUserArgs = {
  InviteUserInput: InviteUserInput;
};


export type MutationLoginArgs = {
  loginUser: LoginUserInput;
};


export type MutationOptOutContactArgs = {
  optOutContactInput: OptOutContactInput;
};


export type MutationRegisterArgs = {
  registerUserInput: RegisterUserInput;
};


export type MutationRemoveSocialSourceArgs = {
  input: RemoveSocialSourceInput;
};


export type MutationRemoveUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationResendOptInLinkArgs = {
  contactOptInInput: ContactOptInLinkInput;
};


export type MutationResendVerificationEmailArgs = {
  resendEmailInput: ResendEmailInput;
};


export type MutationSendOtpArgs = {
  sendOtpInput: SendOtpInput;
};


export type MutationSendOtpV2Args = {
  sendOtpInputV2: SendOtpInput;
};


export type MutationSuperAdminUpdateAdminArgs = {
  superAdminUpdateAdminInput: SuperAdminUpdateAdminInput;
};


export type MutationSwapContactPriorityArgs = {
  swapContactPriorityInput: SwapPriorityInput;
};


export type MutationUpdateCardDetailArgs = {
  updateCardDetails: UpdateCardDetailInput;
};


export type MutationUpdateContactArgs = {
  updateContactInput: UpdateContactInput;
};


export type MutationUpdateCouponArgs = {
  updateCouponInput: UpdateCouponInput;
};


export type MutationUpdateFreePlanArgs = {
  updatePlanInput: UpdatePlanInput;
};


export type MutationUpdateNotificationStatusArgs = {
  updateNotificationInput: UpdateNotificationInput;
};


export type MutationUpdateSocialSourceArgs = {
  updateSocialSourceInput: UpdateSocialSourceInput;
};


export type MutationUpdateSubscriptionPlanArgs = {
  updateSubscriptionPlanInput: UpdateSubscriptionPlan;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateUserPasswordArgs = {
  updateUserPasswordInput: UpdateUserPasswordInput;
};


export type MutationUpdateUserSocialSourceArgs = {
  input: UpdateUserSocialSourceInput;
};


export type MutationUpdateUserStatusFromAdminArgs = {
  status: Scalars['Float']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUserRingMyPhoneSettingsArgs = {
  userRingMyPhoneInput: UserRingMyPhoneInput;
};


export type MutationVerifyEmailTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyInvitationEmailTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyOtpArgs = {
  verifyOtpInput: OtpVerifyInput;
};


export type MutationVerifyResetPasswordTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyResetPasswordTokenAndSetPasswordArgs = {
  resetPasswordInput: ResetPasswordInput;
};

export enum NotificationType {
  AppNotification = 'APP_NOTIFICATION',
  PhoneCall = 'PHONE_CALL'
}

export type OptOutContactInput = {
  token: Scalars['String']['input'];
};

export type OptOutPayload = {
  __typename?: 'OptOutPayload';
  message: Scalars['String']['output'];
};

export enum OtpVerification {
  OtpVerify = 'OTP_VERIFY',
  PhoneVerify = 'PHONE_VERIFY',
  TPinVerify = 'T_PIN_VERIFY'
}

export type OtpVerifyInput = {
  otp: Scalars['String']['input'];
  otpType?: OtpVerification;
};

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type PaginationPayload = {
  __typename?: 'PaginationPayload';
  hasMore: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PauseCollection = {
  __typename?: 'PauseCollection';
  behavior: Scalars['String']['output'];
  resumes_at?: Maybe<Scalars['Float']['output']>;
};

export type PaymentMethodDetails = {
  __typename?: 'PaymentMethodDetails';
  card?: Maybe<Card>;
};

export type PendingInvoiceItemInterval = {
  __typename?: 'PendingInvoiceItemInterval';
  interval: Scalars['String']['output'];
};

export enum PhoneType {
  Cell = 'CELL',
  LandLine = 'LAND_LINE'
}

export type Plan = {
  __typename?: 'Plan';
  active: Scalars['Boolean']['output'];
  aggregate_usage?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_decimal?: Maybe<Scalars['String']['output']>;
  billing_scheme: Scalars['String']['output'];
  created: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  product: Scalars['String']['output'];
  productDetails?: Maybe<Product>;
  tiers?: Maybe<Array<Tier>>;
  tiers_mode?: Maybe<Scalars['String']['output']>;
  transform_usage?: Maybe<TransformUsage>;
  trial_period_days?: Maybe<Scalars['Float']['output']>;
  usage_type: Scalars['String']['output'];
};

export type PlanPayload = {
  __typename?: 'PlanPayload';
  data: Array<Plan>;
  trialEnded?: Maybe<Scalars['Boolean']['output']>;
};

/** device type of fcm token */
export enum PlatFormType {
  Andriod = 'ANDRIOD',
  Ios = 'IOS'
}

export type Product = {
  __typename?: 'Product';
  id: Scalars['String']['output'];
  marketing_features?: Maybe<Array<Feature>>;
  name: Scalars['String']['output'];
};

export type ProductsByIdInput = {
  ids: Array<Scalars['String']['input']>;
};

export type ProductsPayload = {
  __typename?: 'ProductsPayload';
  data?: Maybe<Array<Maybe<Product>>>;
};

export type Query = {
  __typename?: 'Query';
  fetchActiveRedemptions: ActiveRedemptionsPayload;
  fetchAllContacts: Array<Contact>;
  fetchAllOptedOutContacts: Array<Contact>;
  fetchAllUsers: UserPayload;
  fetchCardDetails?: Maybe<Card>;
  fetchContactsByUserId: Array<Contact>;
  fetchCouponsList: CouponsListPayload;
  fetchCustomerInvoices: InvoiceData;
  fetchDefaultMessage: Scalars['String']['output'];
  fetchFreePlan: Plan;
  fetchPlan: PlanPayload;
  fetchProducts: ProductsPayload;
  fetchProductsByIds: ProductsPayload;
  fetchRecentCallLog: RingMyPhoneLogs;
  fetchRingMyPhoneLog: RingMyPhoneLogs;
  fetchSocialSources: SocialSourcePayload;
  fetchUser: User;
  fetchUserByEmail: UserByEmailPayload;
  fetchUserUsageDetails: UserUsageDetailsResponse;
  fetchVipContact?: Maybe<Contact>;
  getSubscriptionDetail: ApiList;
  me: User;
  recentRingMyPhoneLogs: RingMyPhoneCallLogPayload;
  referralsByAssignee: ReferralsPayload;
  retrieveCoupon: CouponPayload;
  retrieveCouponPublic: CouponPayload;
  ringMyPhone: RingMyPhoneLogs;
  validateTokenContact: ValidateContactPayload;
  validateTokenOptIn: ValidateContactPayload;
};


export type QueryFetchActiveRedemptionsArgs = {
  fetchActiveRedemptionsInput: ActiveRedemptionsInput;
};


export type QueryFetchAllUsersArgs = {
  fetchUsersInput: FetchUsersInput;
};


export type QueryFetchCardDetailsArgs = {
  fetchCardDetailsInput: Scalars['String']['input'];
};


export type QueryFetchContactsByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryFetchCouponsListArgs = {
  fetchCouponsListInput: CouponListInput;
};


export type QueryFetchCustomerInvoicesArgs = {
  customerInvoiceInput: InvoiceInput;
};


export type QueryFetchProductsByIdsArgs = {
  fetchProductsByIdInput: ProductsByIdInput;
};


export type QueryFetchRecentCallLogArgs = {
  fetchRecentCallLogInput: FetchRecentCallLogInput;
};


export type QueryFetchRingMyPhoneLogArgs = {
  fetchRingMyPhoneLogInput: FetchRingMyPhoneLogInput;
};


export type QueryFetchSocialSourcesArgs = {
  input: PaginationInput;
};


export type QueryFetchUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryFetchUserByEmailArgs = {
  fetchUserByEmailInput: FetchUserByEmailInput;
};


export type QueryFetchUserUsageDetailsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetSubscriptionDetailArgs = {
  customerStripeId: Scalars['String']['input'];
};


export type QueryRecentRingMyPhoneLogsArgs = {
  input: PaginationInput;
};


export type QueryReferralsByAssigneeArgs = {
  input: ReferralsByAssigneeInput;
};


export type QueryRetrieveCouponArgs = {
  retrieveCouponInput: Scalars['String']['input'];
};


export type QueryRetrieveCouponPublicArgs = {
  retrieveCouponInput: Scalars['String']['input'];
};


export type QueryValidateTokenContactArgs = {
  optOutContactInput: OptOutContactInput;
};


export type QueryValidateTokenOptInArgs = {
  optOutContactInput: OptOutContactInput;
};

export type ReferralsByAssigneeInput = {
  /** Required unless token is provided. */
  assigneeUserId?: InputMaybe<Scalars['String']['input']>;
  paginationOptions: PaginationInput;
  /** Pass a referral ID to get its direct children. Omit to get root-level referrals. */
  parentReferralId?: InputMaybe<Scalars['ID']['input']>;
  /** Browse the referral tree rooted at this user, regardless of assignee. Takes precedence over parentReferralId for the starting node. */
  rootUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by referred user email (partial match). */
  searchEmail?: InputMaybe<Scalars['String']['input']>;
  /** Search by promo code token. Finds the referral with this code and its subtree. */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ReferralsPayload = {
  __typename?: 'ReferralsPayload';
  pagination?: Maybe<PaginationPayload>;
  referrals?: Maybe<Array<Maybe<UserReferral>>>;
};

export type RegisterUserInput = {
  captchaToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
  emailVerified: Scalars['Boolean']['input'];
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  socialSourceId?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveSocialSourceInput = {
  id: Scalars['String']['input'];
};

export type ResendEmailInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
};

export type ResetPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RingMyPhoneCallLogPayload = {
  __typename?: 'RingMyPhoneCallLogPayload';
  pagination?: Maybe<PaginationPayload>;
  ringMyPhoneLogs?: Maybe<Array<RingMyPhoneLogs>>;
};

export type RingMyPhoneLogs = {
  __typename?: 'RingMyPhoneLogs';
  callSid?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  notificationType?: Maybe<NotificationType>;
  phone?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  ringMyPhoneStatus?: Maybe<RingMyPhoneStatus>;
  status?: Maybe<TwillioCallStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum RingMyPhoneStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED'
}

export type Role = {
  __typename?: 'Role';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  role: UserRoles;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendOtpInput = {
  otpType?: OtpVerification;
  phoneNumber: Scalars['String']['input'];
};

export type SendOtpPayload = {
  __typename?: 'SendOtpPayload';
  code?: Maybe<Scalars['String']['output']>;
  sendOtp: Scalars['Boolean']['output'];
};

export type SocialSource = {
  __typename?: 'SocialSource';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  totalUsersReached?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SocialSourcePayload = {
  __typename?: 'SocialSourcePayload';
  pagination?: Maybe<PaginationPayload>;
  socialSources?: Maybe<Array<SocialSource>>;
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  address?: Maybe<Address>;
  balance?: Maybe<Scalars['Float']['output']>;
  created: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  delinquent?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  livemode: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionDto = {
  __typename?: 'SubscriptionDto';
  application?: Maybe<Scalars['String']['output']>;
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  automatic_tax: AutomaticTax;
  billing_cycle_anchor: Scalars['Float']['output'];
  billing_thresholds?: Maybe<BillingThresholds>;
  cancel_at?: Maybe<Scalars['Float']['output']>;
  cancel_at_period_end: Scalars['Boolean']['output'];
  canceled_at?: Maybe<Scalars['Float']['output']>;
  cancellation_details?: Maybe<CancellationDetails>;
  collection_method: Scalars['String']['output'];
  created: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  current_period_end: Scalars['Float']['output'];
  current_period_start: Scalars['Float']['output'];
  customer: Scalars['String']['output'];
  days_until_due?: Maybe<Scalars['Float']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  default_tax_rates?: Maybe<Array<TaxRate>>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Discount>;
  ended_at?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  items: SubscriptionItemDto;
  latest_invoice?: Maybe<Scalars['String']['output']>;
  livemode: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  next_pending_invoice_item_invoice?: Maybe<Scalars['Float']['output']>;
  object: Scalars['String']['output'];
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  pause_collection?: Maybe<PauseCollection>;
  pending_invoice_item_interval?: Maybe<PendingInvoiceItemInterval>;
  schedule?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  transfer_data?: Maybe<TransferData>;
  trial_end?: Maybe<Scalars['Float']['output']>;
  trial_settings?: Maybe<TrialSettings>;
  trial_start?: Maybe<Scalars['Float']['output']>;
};

export type SubscriptionEntity = {
  __typename?: 'SubscriptionEntity';
  callDuration?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** customer stripe ID */
  customerStripeId: Scalars['String']['output'];
  getSubscriptionDetails?: Maybe<ApiList>;
  id: Scalars['ID']['output'];
  subscriptionExpired?: Maybe<SubscriptionExpirationPayload>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionExpirationPayload = {
  __typename?: 'SubscriptionExpirationPayload';
  expirationDate?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  subscribedOnDate?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionFiltersInput = {
  created?: InputMaybe<DateFilter>;
  current_period_end?: InputMaybe<DateFilter>;
  ending_before?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  starting_after?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  billing_thresholds?: Maybe<BillingThresholds>;
  created: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  object: Scalars['String']['output'];
  plan: Plan;
  quantity?: Maybe<Scalars['Float']['output']>;
  subscription: Scalars['String']['output'];
};

export type SubscriptionItemDto = {
  __typename?: 'SubscriptionItemDTO';
  data: Array<SubscriptionItem>;
  has_more: Scalars['Boolean']['output'];
  object: Scalars['String']['output'];
  total_count: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type SuperAdminUpdateAdminInput = {
  fullName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SwapPriorityInput = {
  idOne: Scalars['String']['input'];
  idTwo: Scalars['String']['input'];
  priorityOne: Scalars['Int']['input'];
  priorityTwo: Scalars['Int']['input'];
};

export type TaxRate = {
  __typename?: 'TaxRate';
  active: Scalars['Boolean']['output'];
  country: Scalars['String']['output'];
  created: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  effective_percentage: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  inclusive: Scalars['Boolean']['output'];
  jurisdiction: Scalars['String']['output'];
  livemode: Scalars['Boolean']['output'];
  object: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  state: Scalars['String']['output'];
};

export type Tier = {
  __typename?: 'Tier';
  flat_amount?: Maybe<Scalars['Int']['output']>;
  flat_amount_decimal?: Maybe<Scalars['String']['output']>;
  unit_amount?: Maybe<Scalars['Float']['output']>;
  unit_amount_decimal?: Maybe<Scalars['String']['output']>;
  up_to?: Maybe<Scalars['Float']['output']>;
};

export type TotalDiscountAmount = {
  __typename?: 'TotalDiscountAmount';
  amount: Scalars['Float']['output'];
  discount: Scalars['String']['output'];
};

export type TransferData = {
  __typename?: 'TransferData';
  amount_percent: Scalars['Float']['output'];
  destination: Scalars['String']['output'];
};

export type TransformUsage = {
  __typename?: 'TransformUsage';
  divide_by: Scalars['Float']['output'];
  round: Scalars['String']['output'];
};

export type TrialSettings = {
  __typename?: 'TrialSettings';
  end_behavior: EndBehavior;
};

export enum TwillioCallStatus {
  Busy = 'BUSY',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NoAnswer = 'NO_ANSWER',
  Queued = 'QUEUED',
  Ringing = 'RINGING'
}

export type UpdateCardDetailInput = {
  account_holder_name?: InputMaybe<Scalars['String']['input']>;
  account_holder_type?: InputMaybe<Scalars['String']['input']>;
  address_city?: InputMaybe<Scalars['String']['input']>;
  address_country?: InputMaybe<Scalars['String']['input']>;
  address_line1?: InputMaybe<Scalars['String']['input']>;
  address_line2?: InputMaybe<Scalars['String']['input']>;
  address_state?: InputMaybe<Scalars['String']['input']>;
  address_zip?: InputMaybe<Scalars['String']['input']>;
  customerStripeId: Scalars['String']['input'];
  exp_month?: InputMaybe<Scalars['String']['input']>;
  exp_year?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactInput = {
  contactLimit?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneType?: InputMaybe<PhoneType>;
};

export type UpdateCouponInput = {
  /** Coupon id/code to update. */
  code: Scalars['String']['input'];
  /** Key-value metadata (e.g. salesPersonId, phoneNumber). Fully editable in Stripe; pass the full metadata object to set/replace. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Display name for the coupon (editable in Stripe). */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationInput = {
  id: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlanInput = {
  id: Scalars['String']['input'];
  trial_period_days: Scalars['Int']['input'];
};

export type UpdatePlanPayload = {
  __typename?: 'UpdatePlanPayload';
  id: Scalars['String']['output'];
  trial_period_days: Scalars['Int']['output'];
};

export type UpdateSocialSourceInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionPlan = {
  description?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
  subscriptionItemId: Scalars['String']['input'];
};

export type UpdateUserInput = {
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  socialSourceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserPasswordInput = {
  newPassword: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateUserSocialSourceInput = {
  socialSourceId: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  contacts?: Maybe<Array<Maybe<Contact>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultMessage?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  enablePhoneRinger?: Maybe<Scalars['Boolean']['output']>;
  fcmToken?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSubscribed?: Maybe<IsSubscribed>;
  isTPinAdded?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberSid?: Maybe<Scalars['String']['output']>;
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  platform?: Maybe<PlatFormType>;
  ringMyPhoneLogs?: Maybe<Array<Maybe<RingMyPhoneLogs>>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  showLogo: Scalars['Boolean']['output'];
  status: UserStatus;
  subscription?: Maybe<SubscriptionEntity>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userSocialSource?: Maybe<UserSocialSource>;
};

export type UserByEmailPayload = {
  __typename?: 'UserByEmailPayload';
  id: Scalars['String']['output'];
};

export type UserPayload = {
  __typename?: 'UserPayload';
  pagination?: Maybe<PaginationPayload>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type UserReferral = {
  __typename?: 'UserReferral';
  assigneeUser?: Maybe<User>;
  assigneeUserId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  directChildCount?: Maybe<Scalars['Float']['output']>;
  freeMonthsAtApply?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  promoCode: Scalars['String']['output'];
  referredUser?: Maybe<User>;
  referredUserId?: Maybe<Scalars['ID']['output']>;
  referrerUser?: Maybe<User>;
  referrerUserId?: Maybe<Scalars['ID']['output']>;
  rootPromoCodeId?: Maybe<Scalars['String']['output']>;
  totalDescendantCount?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserRingMyPhoneInput = {
  defaultMessage: Scalars['Boolean']['input'];
  enablePhoneRinger: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  showLogo: Scalars['Boolean']['input'];
};

export type UserSocialSource = {
  __typename?: 'UserSocialSource';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  socialSource?: Maybe<SocialSource>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The user status */
export enum UserStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Pending = 'PENDING'
}

export type UserUsageDetailsResponse = {
  __typename?: 'UserUsageDetailsResponse';
  currentMonthUsage?: Maybe<Scalars['Int']['output']>;
  overAllUsage?: Maybe<Scalars['Int']['output']>;
  user: User;
};

export type ValidateContactPayload = {
  __typename?: 'ValidateContactPayload';
  name: Scalars['String']['output'];
  phoneNo: Scalars['String']['output'];
};

export type VerifyOtpPayload = {
  __typename?: 'VerifyOtpPayload';
  otpVerified: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ConfirmWalletPaymentPayload = {
  __typename?: 'confirmWalletPaymentPayload';
  customerStripeId: Scalars['String']['output'];
};

export enum Duration {
  Forever = 'FOREVER',
  Once = 'ONCE',
  Repeating = 'REPEATING'
}

/** The user role assigned */
export enum UserRoles {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Sales = 'SALES',
  SuperAdmin = 'SUPER_ADMIN'
}

export type FetchAllUsersQueryVariables = Exact<{
  fetchUsersInput: FetchUsersInput;
}>;


export type FetchAllUsersQuery = { __typename?: 'Query', fetchAllUsers: { __typename?: 'UserPayload', pagination?: { __typename?: 'PaginationPayload', limit?: number | null, page?: number | null, totalCount?: number | null, totalPages?: number | null, hasMore: boolean } | null, users?: Array<{ __typename?: 'User', fullName?: string | null, emailVerified: boolean, id: string, updatedAt?: any | null, showLogo: boolean, createdAt?: any | null, email: string, status: UserStatus, subscription?: { __typename?: 'SubscriptionEntity', createdAt?: any | null, customerStripeId: string, id: string, updatedAt?: any | null, getSubscriptionDetails?: { __typename?: 'ApiList', has_more?: boolean | null, url: string, data: Array<{ __typename?: 'SubscriptionDto', application?: string | null, application_fee_percent?: number | null, billing_cycle_anchor: number, cancel_at?: number | null, cancel_at_period_end: boolean, canceled_at?: number | null, collection_method: string, created: number, currency: string, current_period_end: number, current_period_start: number, customer: string, days_until_due?: number | null, default_payment_method?: string | null, default_source?: string | null, description?: string | null, ended_at?: number | null, id: string, latest_invoice?: string | null, livemode: boolean, metadata?: any | null, next_pending_invoice_item_invoice?: number | null, object: string, on_behalf_of?: string | null, schedule?: string | null, start_date: number, status: string, trial_end?: number | null, trial_start?: number | null, automatic_tax: { __typename?: 'AutomaticTax', enabled: boolean }, billing_thresholds?: { __typename?: 'BillingThresholds', amount_gte: number, reset_billing_cycle_anchor?: boolean | null } | null, cancellation_details?: { __typename?: 'CancellationDetails', comment?: string | null, feedback?: string | null, reason?: string | null } | null, default_tax_rates?: Array<{ __typename?: 'TaxRate', active: boolean, country: string, created: number, description: string, display_name: string, effective_percentage: number, id: string, inclusive: boolean, jurisdiction: string, livemode: boolean, object: string, percentage: number, state: string }> | null, discount?: { __typename?: 'Discount', checkout_session?: string | null, id: string, object: string, start: number, coupon: { __typename?: 'Coupon', amount_off?: number | null, created: number, currency?: string | null, deleted: boolean, duration: string, duration_in_months?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, name?: string | null, object: string, percent_off?: number | null, redeem_by?: number | null, times_redeemed: number, valid: boolean, applies_to?: { __typename?: 'AppliesToProducts', products: Array<string> } | null } } | null, items: { __typename?: 'SubscriptionItemDTO', has_more: boolean, object: string, total_count: number, url: string, data: Array<{ __typename?: 'SubscriptionItem', created: number, id: string, object: string, quantity?: number | null, subscription: string, billing_thresholds?: { __typename?: 'BillingThresholds', amount_gte: number, reset_billing_cycle_anchor?: boolean | null } | null, plan: { __typename?: 'Plan', active: boolean, aggregate_usage?: string | null, amount?: number | null, amount_decimal?: string | null, billing_scheme: string, created: number, currency: string, id: string, interval: string, metadata?: any | null, nickname?: string | null, object: string, product: string, tiers_mode?: string | null, trial_period_days?: number | null, usage_type: string, tiers?: Array<{ __typename?: 'Tier', flat_amount?: number | null, flat_amount_decimal?: string | null, unit_amount?: number | null, unit_amount_decimal?: string | null, up_to?: number | null }> | null, transform_usage?: { __typename?: 'TransformUsage', divide_by: number, round: string } | null } }> }, pause_collection?: { __typename?: 'PauseCollection', behavior: string, resumes_at?: number | null } | null, pending_invoice_item_interval?: { __typename?: 'PendingInvoiceItemInterval', interval: string } | null, transfer_data?: { __typename?: 'TransferData', amount_percent: number, destination: string } | null, trial_settings?: { __typename?: 'TrialSettings', end_behavior: { __typename?: 'EndBehavior', missing_payment_method: string } } | null }> } | null, subscriptionExpired?: { __typename?: 'SubscriptionExpirationPayload', planName?: string | null, expirationDate?: string | null, subscribedOnDate?: string | null } | null } | null, roles?: Array<{ __typename?: 'Role', createdAt?: any | null, id: string, role: UserRoles, updatedAt?: any | null } | null> | null, contacts?: Array<{ __typename?: 'Contact', createdAt?: any | null, id: string, email?: string | null, name: string, nickName: string, phoneNumber: string, phoneType: PhoneType, priority: number, updatedAt?: any | null, status?: ContactStatus | null, declinedCount?: number | null } | null> | null } | null> | null } };

export type LoginMutationVariables = Exact<{
  loginUser: LoginUserInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AccessUserPayload', accessToken?: string | null } };

export type RegisterMutationVariables = Exact<{
  registerUserInput: RegisterUserInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'User', email: string, emailVerified: boolean, fullName?: string | null, phoneNumber?: string | null, status: UserStatus, roles?: Array<{ __typename?: 'Role', role: UserRoles } | null> | null } };

export type ForgotPasswordMutationVariables = Exact<{
  forgotPasswordInput: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type VerifyResetPasswordTokenAndSetPasswordMutationVariables = Exact<{
  resetPasswordInput: ResetPasswordInput;
}>;


export type VerifyResetPasswordTokenAndSetPasswordMutation = { __typename?: 'Mutation', verifyResetPasswordTokenAndSetPassword: boolean };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, createdAt?: any | null, updatedAt?: any | null, fullName?: string | null, status: UserStatus, email: string, emailVerified: boolean, phoneNumber?: string | null, showLogo: boolean, isTPinAdded?: boolean | null, roles?: Array<{ __typename?: 'Role', role: UserRoles, id: string, createdAt?: any | null, updatedAt?: any | null } | null> | null, isSubscribed?: { __typename?: 'IsSubscribed', customerStripeId?: string | null } | null } };

export type VerifyEmailTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyEmailTokenMutation = { __typename?: 'Mutation', verifyEmailToken: { __typename?: 'InviteUserPayload', email: string, roleType?: UserRoles | null } };

export type AdminRegisterMutationVariables = Exact<{
  registerAdminUserInput: AdminRegisterUserInput;
}>;


export type AdminRegisterMutation = { __typename?: 'Mutation', adminRegister: { __typename?: 'User', fullName?: string | null, roles?: Array<{ __typename?: 'Role', role: UserRoles } | null> | null } };

export type FetchCouponsListQueryVariables = Exact<{
  fetchCouponsListInput: CouponListInput;
}>;


export type FetchCouponsListQuery = { __typename?: 'Query', fetchCouponsList: { __typename?: 'CouponsListPayload', has_more?: boolean | null, data: Array<{ __typename?: 'Coupon', amount_off?: number | null, created: number, currency?: string | null, deleted: boolean, duration: string, duration_in_months?: number | null, id: string, livemode: boolean, metadata?: any | null, max_redemptions?: number | null, name?: string | null, object: string, percent_off?: number | null, redeem_by?: number | null, times_redeemed: number, valid: boolean, applies_to?: { __typename?: 'AppliesToProducts', products: Array<string> } | null }> } };

export type CreateCouponMutationVariables = Exact<{
  createCouponInput: CreateCouponInput;
}>;


export type CreateCouponMutation = { __typename?: 'Mutation', createCoupon: boolean };

export type FetchProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchProductsQuery = { __typename?: 'Query', fetchProducts: { __typename?: 'ProductsPayload', data?: Array<{ __typename?: 'Product', id: string, name: string } | null> | null } };

export type DeleteCouponMutationVariables = Exact<{
  deleteCouponInput: Scalars['String']['input'];
}>;


export type DeleteCouponMutation = { __typename?: 'Mutation', deleteCoupon: boolean };

export type UpdateCouponMutationVariables = Exact<{
  updateCouponInput: UpdateCouponInput;
}>;


export type UpdateCouponMutation = { __typename?: 'Mutation', updateCoupon: boolean };

export type FetchActiveRedemptionsQueryVariables = Exact<{
  fetchActiveRedemptionsInput: ActiveRedemptionsInput;
}>;


export type FetchActiveRedemptionsQuery = { __typename?: 'Query', fetchActiveRedemptions: { __typename?: 'ActiveRedemptionsPayload', has_more?: boolean | null, next_page?: string | null, url?: string | null, data?: Array<{ __typename?: 'StripeCustomer', id: string, email?: string | null, created: number, name?: string | null, balance?: number | null, object: string, livemode: boolean, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null } | null> | null } };

export type FetchProductsByIdsQueryVariables = Exact<{
  fetchProductsByIdInput: ProductsByIdInput;
}>;


export type FetchProductsByIdsQuery = { __typename?: 'Query', fetchProductsByIds: { __typename?: 'ProductsPayload', data?: Array<{ __typename?: 'Product', id: string, name: string } | null> | null } };

export type FetchUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FetchUserQuery = { __typename?: 'Query', fetchUser: { __typename?: 'User', createdAt?: any | null, email: string, emailVerified: boolean, fullName?: string | null, id: string, showLogo: boolean, isTPinAdded?: boolean | null, phoneNumber?: string | null, status: UserStatus, updatedAt?: any | null, isSubscribed?: { __typename?: 'IsSubscribed', customerStripeId?: string | null } | null, roles?: Array<{ __typename?: 'Role', createdAt?: any | null, id: string, role: UserRoles, updatedAt?: any | null } | null> | null } };

export type FetchContactsByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FetchContactsByUserIdQuery = { __typename?: 'Query', fetchContactsByUserId: Array<{ __typename?: 'Contact', createdAt?: any | null, id: string, name: string, nickName: string, phoneNumber: string, phoneType: PhoneType, priority: number, updatedAt?: any | null, email?: string | null, status?: ContactStatus | null, declinedCount?: number | null }> };

export type FetchCustomerInvoicesQueryVariables = Exact<{
  customerInvoiceInput: InvoiceInput;
}>;


export type FetchCustomerInvoicesQuery = { __typename?: 'Query', fetchCustomerInvoices: { __typename?: 'InvoiceData', has_more: boolean, url: string, data?: Array<{ __typename?: 'Invoice', account_country: string, account_name: string, amount_due: number, amount_paid: number, amount_remaining: number, attempt_count: number, billing_reason?: string | null, created: number, currency?: string | null, customer?: string | null, customer_email?: string | null, hosted_invoice_url?: string | null, id: string, invoice_pdf?: string | null, number?: string | null, object: string, paid: boolean, period_end?: number | null, period_start?: number | null, status: string, subtotal: number, subtotal_excluding_tax: number, total: number, charge?: { __typename?: 'Charge', amount?: number | null, created: number, description?: string | null, failure_code?: string | null, failure_message?: string | null, id: string, object: string, paid: boolean, receipt_number?: string | null, receipt_url?: string | null, status: string } | null, total_discount_amounts?: Array<{ __typename?: 'TotalDiscountAmount', amount: number, discount: string }> | null } | null> | null } };

export type FetchBillingDetailsQueryVariables = Exact<{
  fetchCardDetailsInput: Scalars['String']['input'];
}>;


export type FetchBillingDetailsQuery = { __typename?: 'Query', fetchCardDetails?: { __typename?: 'Card', address_line1?: string | null, address_line2?: string | null, address_state?: string | null, address_zip?: string | null, address_city?: string | null, address_country?: string | null, customer_name?: string | null, name?: string | null, exp_month?: number | null, exp_year?: number | null, last4: string, brand?: string | null } | null };

export type SuperAdminUpdateAdminMutationVariables = Exact<{
  superAdminUpdateAdminInput: SuperAdminUpdateAdminInput;
}>;


export type SuperAdminUpdateAdminMutation = { __typename?: 'Mutation', superAdminUpdateAdmin: { __typename?: 'AdminUpdatePayload', fullName: string } };

export type FetchUserUsageDetailsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FetchUserUsageDetailsQuery = { __typename?: 'Query', fetchUserUsageDetails: { __typename?: 'UserUsageDetailsResponse', currentMonthUsage?: number | null, overAllUsage?: number | null } };

export type GetSubscriptionDetailQueryVariables = Exact<{
  customerStripeId: Scalars['String']['input'];
}>;


export type GetSubscriptionDetailQuery = { __typename?: 'Query', getSubscriptionDetail: { __typename?: 'ApiList', data: Array<{ __typename?: 'SubscriptionDto', application?: string | null, application_fee_percent?: number | null, billing_cycle_anchor: number, cancel_at?: number | null, cancel_at_period_end: boolean, canceled_at?: number | null, created: number, default_payment_method?: string | null, default_source?: string | null, description?: string | null, ended_at?: number | null, id: string, latest_invoice?: string | null, livemode: boolean, next_pending_invoice_item_invoice?: number | null, object: string, on_behalf_of?: string | null, schedule?: string | null, start_date: number, status: string, trial_end?: number | null, trial_start?: number | null, metadata?: any | null, current_period_end: number, automatic_tax: { __typename?: 'AutomaticTax', enabled: boolean }, billing_thresholds?: { __typename?: 'BillingThresholds', amount_gte: number, reset_billing_cycle_anchor?: boolean | null } | null, cancellation_details?: { __typename?: 'CancellationDetails', comment?: string | null, feedback?: string | null, reason?: string | null } | null, default_tax_rates?: Array<{ __typename?: 'TaxRate', active: boolean, country: string, created: number, description: string, display_name: string, effective_percentage: number, id: string, inclusive: boolean, jurisdiction: string, livemode: boolean, object: string, percentage: number, state: string }> | null, items: { __typename?: 'SubscriptionItemDTO', data: Array<{ __typename?: 'SubscriptionItem', created: number, id: string, object: string, quantity?: number | null, subscription: string, plan: { __typename?: 'Plan', nickname?: string | null, amount?: number | null, product: string, metadata?: any | null, interval: string, id: string, created: number, active: boolean, aggregate_usage?: string | null, amount_decimal?: string | null, billing_scheme: string, currency: string, object: string, tiers_mode?: string | null, trial_period_days?: number | null, usage_type: string, transform_usage?: { __typename?: 'TransformUsage', divide_by: number, round: string } | null } }> }, pause_collection?: { __typename?: 'PauseCollection', behavior: string, resumes_at?: number | null } | null, pending_invoice_item_interval?: { __typename?: 'PendingInvoiceItemInterval', interval: string } | null, transfer_data?: { __typename?: 'TransferData', amount_percent: number, destination: string } | null, trial_settings?: { __typename?: 'TrialSettings', end_behavior: { __typename?: 'EndBehavior', missing_payment_method: string } } | null }> } };

export type FetchAllContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllContactsQuery = { __typename?: 'Query', fetchAllContacts: Array<{ __typename?: 'Contact', id: string, createdAt?: any | null, updatedAt?: any | null, phoneNumber: string, priority: number, nickName: string, name: string, phoneType: PhoneType }> };

export type DeleteUserMutationVariables = Exact<{
  deleteUserInput: DeleteUserInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: string };

export type ResendOptInLinkMutationVariables = Exact<{
  contactOptInInput: ContactOptInLinkInput;
}>;


export type ResendOptInLinkMutation = { __typename?: 'Mutation', resendOptInLink: string };

export type FetchUserByEmailQueryVariables = Exact<{
  fetchUserByEmailInput: FetchUserByEmailInput;
}>;


export type FetchUserByEmailQuery = { __typename?: 'Query', fetchUserByEmail: { __typename?: 'UserByEmailPayload', id: string } };

export type InviteUserMutationVariables = Exact<{
  inviteUserInput: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: boolean };

export type SendOtpMutationVariables = Exact<{
  sendOtpInput: SendOtpInput;
}>;


export type SendOtpMutation = { __typename?: 'Mutation', sendOtp: { __typename?: 'SendOtpPayload', code?: string | null, sendOtp: boolean } };

export type VerifyOtpMutationVariables = Exact<{
  verifyOtpInput: OtpVerifyInput;
}>;


export type VerifyOtpMutation = { __typename?: 'Mutation', verifyOtp: { __typename?: 'VerifyOtpPayload', phoneNumber?: string | null } };

export type AddSecurityPinMutationVariables = Exact<{
  addOrUpdateSecurityPinInput: AddOrUpdateSecurityPin;
}>;


export type AddSecurityPinMutation = { __typename?: 'Mutation', addSecurityPin: boolean };

export type FetchPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPlanQuery = { __typename?: 'Query', fetchPlan: { __typename?: 'PlanPayload', data: Array<{ __typename?: 'Plan', active: boolean, aggregate_usage?: string | null, amount?: number | null, amount_decimal?: string | null, billing_scheme: string, created: number, currency: string, id: string, interval: string, metadata?: any | null, nickname?: string | null, object: string, product: string, tiers_mode?: string | null, trial_period_days?: number | null, usage_type: string, tiers?: Array<{ __typename?: 'Tier', flat_amount?: number | null, flat_amount_decimal?: string | null, unit_amount?: number | null, unit_amount_decimal?: string | null, up_to?: number | null }> | null, transform_usage?: { __typename?: 'TransformUsage', divide_by: number, round: string } | null }> } };

export type RetrieveCouponQueryVariables = Exact<{
  retrieveCouponInput: Scalars['String']['input'];
}>;


export type RetrieveCouponQuery = { __typename?: 'Query', retrieveCoupon: { __typename?: 'CouponPayload', amountOff?: number | null, name?: string | null, percentOff?: number | null, products?: Array<string> | null } };

export type CreateSubscriptionMutationVariables = Exact<{
  createSubscriptionInput: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'SubscriptionEntity', customerStripeId: string } };

export type UpdateNameMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateNameMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', fullName?: string | null } };

export type UpdateEmailMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', email: string } };

export type UpdateUserPasswordMutationVariables = Exact<{
  updateUserPasswordInput: UpdateUserPasswordInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword: { __typename?: 'User', id: string } };

export type UpdatePhoneNumberMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdatePhoneNumberMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', phoneNumber?: string | null } };

export type DeactivateUserAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeactivateUserAccountMutation = { __typename?: 'Mutation', deactivateUserAccount: { __typename?: 'User', status: UserStatus } };

export type AdminUpdateCustomerEmailMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type AdminUpdateCustomerEmailMutation = { __typename?: 'Mutation', adminUpdateCustomerEmail: { __typename?: 'User', id: string, email: string } };

export type ReferralsByAssigneeQueryVariables = Exact<{
  input: ReferralsByAssigneeInput;
}>;


export type ReferralsByAssigneeQuery = { __typename?: 'Query', referralsByAssignee: { __typename?: 'ReferralsPayload', pagination?: { __typename?: 'PaginationPayload', hasMore: boolean, limit?: number | null, page?: number | null, totalCount?: number | null, totalPages?: number | null } | null, referrals?: Array<{ __typename?: 'UserReferral', id: string, promoCode: string, assigneeUserId?: string | null, referredUserId?: string | null, referrerUserId?: string | null, rootPromoCodeId?: string | null, createdAt?: any | null, updatedAt?: any | null, directChildCount?: number | null, totalDescendantCount?: number | null, freeMonthsAtApply?: number | null, assigneeUser?: { __typename?: 'User', id: string, fullName?: string | null, email: string } | null, referredUser?: { __typename?: 'User', id: string, fullName?: string | null, email: string } | null, referrerUser?: { __typename?: 'User', id: string, fullName?: string | null, email: string } | null } | null> | null } };

export type FetchSocialSourcesQueryVariables = Exact<{
  input: PaginationInput;
}>;


export type FetchSocialSourcesQuery = { __typename?: 'Query', fetchSocialSources: { __typename?: 'SocialSourcePayload', pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, limit?: number | null, totalPages?: number | null } | null, socialSources?: Array<{ __typename?: 'SocialSource', id: string, name?: string | null, totalUsersReached?: number | null }> | null } };

export type CreateSocialSourceMutationVariables = Exact<{
  createSocialSourceInput: CreateSocialSourceInput;
}>;


export type CreateSocialSourceMutation = { __typename?: 'Mutation', createSocialSource: { __typename?: 'SocialSource', name?: string | null } };

export type RemoveSocialSourceMutationVariables = Exact<{
  input: RemoveSocialSourceInput;
}>;


export type RemoveSocialSourceMutation = { __typename?: 'Mutation', removeSocialSource: boolean };

export type UpdateSocialSourceMutationVariables = Exact<{
  updateSocialSourceInput: UpdateSocialSourceInput;
}>;


export type UpdateSocialSourceMutation = { __typename?: 'Mutation', updateSocialSource: { __typename?: 'SocialSource', id: string, name?: string | null } };

export type FetchFreePlanQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFreePlanQuery = { __typename?: 'Query', fetchFreePlan: { __typename?: 'Plan', id: string, nickname?: string | null, amount?: number | null, trial_period_days?: number | null } };

export type UpdateFreePlanMutationVariables = Exact<{
  updatePlanInput: UpdatePlanInput;
}>;


export type UpdateFreePlanMutation = { __typename?: 'Mutation', updateFreePlan: { __typename?: 'UpdatePlanPayload', id: string, trial_period_days: number } };

export type UpdateUserStatusFromAdminMutationVariables = Exact<{
  status: Scalars['Float']['input'];
  userId: Scalars['String']['input'];
}>;


export type UpdateUserStatusFromAdminMutation = { __typename?: 'Mutation', updateUserStatusFromAdmin: { __typename?: 'User', createdAt?: any | null, email: string, emailVerified: boolean, fullName?: string | null, id: string, isTPinAdded?: boolean | null, phoneNumber?: string | null, status: UserStatus, updatedAt?: any | null, isSubscribed?: { __typename?: 'IsSubscribed', customerStripeId?: string | null } | null, roles?: Array<{ __typename?: 'Role', createdAt?: any | null, id: string, role: UserRoles, updatedAt?: any | null } | null> | null } };


export const FetchAllUsersDocument = gql`
    query FetchAllUsers($fetchUsersInput: FetchUsersInput!) {
  fetchAllUsers(fetchUsersInput: $fetchUsersInput) {
    pagination {
      limit
      page
      totalCount
      totalPages
      hasMore
    }
    users {
      fullName
      emailVerified
      id
      updatedAt
      showLogo
      subscription {
        createdAt
        customerStripeId
        id
        updatedAt
        getSubscriptionDetails {
          has_more
          url
          data {
            application
            application_fee_percent
            automatic_tax {
              enabled
            }
            billing_cycle_anchor
            billing_thresholds {
              amount_gte
              reset_billing_cycle_anchor
            }
            cancel_at
            cancel_at_period_end
            canceled_at
            cancellation_details {
              comment
              feedback
              reason
            }
            collection_method
            created
            currency
            current_period_end
            current_period_start
            customer
            days_until_due
            default_payment_method
            default_source
            default_tax_rates {
              active
              country
              created
              description
              display_name
              effective_percentage
              id
              inclusive
              jurisdiction
              livemode
              object
              percentage
              state
            }
            description
            discount {
              checkout_session
              coupon {
                amount_off
                applies_to {
                  products
                }
                created
                currency
                deleted
                duration
                duration_in_months
                id
                livemode
                max_redemptions
                name
                object
                percent_off
                redeem_by
                times_redeemed
                valid
              }
              id
              object
              start
            }
            ended_at
            id
            items {
              data {
                billing_thresholds {
                  amount_gte
                  reset_billing_cycle_anchor
                }
                created
                id
                object
                plan {
                  active
                  aggregate_usage
                  amount
                  amount_decimal
                  billing_scheme
                  created
                  currency
                  id
                  interval
                  metadata
                  nickname
                  object
                  product
                  tiers {
                    flat_amount
                    flat_amount_decimal
                    unit_amount
                    unit_amount_decimal
                    up_to
                  }
                  tiers_mode
                  transform_usage {
                    divide_by
                    round
                  }
                  trial_period_days
                  usage_type
                }
                quantity
                subscription
              }
              has_more
              object
              total_count
              url
            }
            latest_invoice
            livemode
            metadata
            next_pending_invoice_item_invoice
            object
            on_behalf_of
            pause_collection {
              behavior
              resumes_at
            }
            pending_invoice_item_interval {
              interval
            }
            schedule
            start_date
            status
            transfer_data {
              amount_percent
              destination
            }
            trial_end
            trial_settings {
              end_behavior {
                missing_payment_method
              }
            }
            trial_start
          }
        }
        subscriptionExpired {
          planName
          expirationDate
          subscribedOnDate
        }
      }
      createdAt
      email
      status
      roles {
        createdAt
        id
        role
        updatedAt
      }
      contacts {
        createdAt
        id
        email
        name
        nickName
        phoneNumber
        phoneType
        priority
        updatedAt
        status
        declinedCount
      }
    }
  }
}
    `;

/**
 * __useFetchAllUsersQuery__
 *
 * To run a query within a React component, call `useFetchAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllUsersQuery({
 *   variables: {
 *      fetchUsersInput: // value for 'fetchUsersInput'
 *   },
 * });
 */
export function useFetchAllUsersQuery(baseOptions: Apollo.QueryHookOptions<FetchAllUsersQuery, FetchAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllUsersQuery, FetchAllUsersQueryVariables>(FetchAllUsersDocument, options);
      }
export function useFetchAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllUsersQuery, FetchAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllUsersQuery, FetchAllUsersQueryVariables>(FetchAllUsersDocument, options);
        }
export type FetchAllUsersQueryHookResult = ReturnType<typeof useFetchAllUsersQuery>;
export type FetchAllUsersLazyQueryHookResult = ReturnType<typeof useFetchAllUsersLazyQuery>;
export type FetchAllUsersQueryResult = Apollo.QueryResult<FetchAllUsersQuery, FetchAllUsersQueryVariables>;
export const LoginDocument = gql`
    mutation Login($loginUser: LoginUserInput!) {
  login(loginUser: $loginUser) {
    accessToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      loginUser: // value for 'loginUser'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($registerUserInput: RegisterUserInput!) {
  register(registerUserInput: $registerUserInput) {
    email
    emailVerified
    fullName
    phoneNumber
    status
    roles {
      role
    }
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      registerUserInput: // value for 'registerUserInput'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($forgotPasswordInput: ForgotPasswordInput!) {
  forgotPassword(forgotPasswordInput: $forgotPasswordInput)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      forgotPasswordInput: // value for 'forgotPasswordInput'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const VerifyResetPasswordTokenAndSetPasswordDocument = gql`
    mutation VerifyResetPasswordTokenAndSetPassword($resetPasswordInput: ResetPasswordInput!) {
  verifyResetPasswordTokenAndSetPassword(resetPasswordInput: $resetPasswordInput)
}
    `;
export type VerifyResetPasswordTokenAndSetPasswordMutationFn = Apollo.MutationFunction<VerifyResetPasswordTokenAndSetPasswordMutation, VerifyResetPasswordTokenAndSetPasswordMutationVariables>;

/**
 * __useVerifyResetPasswordTokenAndSetPasswordMutation__
 *
 * To run a mutation, you first call `useVerifyResetPasswordTokenAndSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyResetPasswordTokenAndSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyResetPasswordTokenAndSetPasswordMutation, { data, loading, error }] = useVerifyResetPasswordTokenAndSetPasswordMutation({
 *   variables: {
 *      resetPasswordInput: // value for 'resetPasswordInput'
 *   },
 * });
 */
export function useVerifyResetPasswordTokenAndSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<VerifyResetPasswordTokenAndSetPasswordMutation, VerifyResetPasswordTokenAndSetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyResetPasswordTokenAndSetPasswordMutation, VerifyResetPasswordTokenAndSetPasswordMutationVariables>(VerifyResetPasswordTokenAndSetPasswordDocument, options);
      }
export type VerifyResetPasswordTokenAndSetPasswordMutationHookResult = ReturnType<typeof useVerifyResetPasswordTokenAndSetPasswordMutation>;
export type VerifyResetPasswordTokenAndSetPasswordMutationResult = Apollo.MutationResult<VerifyResetPasswordTokenAndSetPasswordMutation>;
export type VerifyResetPasswordTokenAndSetPasswordMutationOptions = Apollo.BaseMutationOptions<VerifyResetPasswordTokenAndSetPasswordMutation, VerifyResetPasswordTokenAndSetPasswordMutationVariables>;
export const GetUserDocument = gql`
    query GetUser {
  me {
    id
    createdAt
    updatedAt
    fullName
    status
    email
    emailVerified
    phoneNumber
    showLogo
    roles {
      role
      id
      createdAt
      updatedAt
    }
    isSubscribed {
      customerStripeId
    }
    isTPinAdded
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const VerifyEmailTokenDocument = gql`
    mutation VerifyEmailToken($token: String!) {
  verifyEmailToken(token: $token) {
    email
    roleType
  }
}
    `;
export type VerifyEmailTokenMutationFn = Apollo.MutationFunction<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>;

/**
 * __useVerifyEmailTokenMutation__
 *
 * To run a mutation, you first call `useVerifyEmailTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailTokenMutation, { data, loading, error }] = useVerifyEmailTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>(VerifyEmailTokenDocument, options);
      }
export type VerifyEmailTokenMutationHookResult = ReturnType<typeof useVerifyEmailTokenMutation>;
export type VerifyEmailTokenMutationResult = Apollo.MutationResult<VerifyEmailTokenMutation>;
export type VerifyEmailTokenMutationOptions = Apollo.BaseMutationOptions<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>;
export const AdminRegisterDocument = gql`
    mutation AdminRegister($registerAdminUserInput: AdminRegisterUserInput!) {
  adminRegister(registerAdminUserInput: $registerAdminUserInput) {
    fullName
    roles {
      role
    }
  }
}
    `;
export type AdminRegisterMutationFn = Apollo.MutationFunction<AdminRegisterMutation, AdminRegisterMutationVariables>;

/**
 * __useAdminRegisterMutation__
 *
 * To run a mutation, you first call `useAdminRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRegisterMutation, { data, loading, error }] = useAdminRegisterMutation({
 *   variables: {
 *      registerAdminUserInput: // value for 'registerAdminUserInput'
 *   },
 * });
 */
export function useAdminRegisterMutation(baseOptions?: Apollo.MutationHookOptions<AdminRegisterMutation, AdminRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRegisterMutation, AdminRegisterMutationVariables>(AdminRegisterDocument, options);
      }
export type AdminRegisterMutationHookResult = ReturnType<typeof useAdminRegisterMutation>;
export type AdminRegisterMutationResult = Apollo.MutationResult<AdminRegisterMutation>;
export type AdminRegisterMutationOptions = Apollo.BaseMutationOptions<AdminRegisterMutation, AdminRegisterMutationVariables>;
export const FetchCouponsListDocument = gql`
    query FetchCouponsList($fetchCouponsListInput: CouponListInput!) {
  fetchCouponsList(fetchCouponsListInput: $fetchCouponsListInput) {
    data {
      amount_off
      applies_to {
        products
      }
      created
      currency
      deleted
      duration
      duration_in_months
      id
      livemode
      metadata
      max_redemptions
      name
      object
      percent_off
      redeem_by
      times_redeemed
      valid
      times_redeemed
    }
    has_more
  }
}
    `;

/**
 * __useFetchCouponsListQuery__
 *
 * To run a query within a React component, call `useFetchCouponsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCouponsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCouponsListQuery({
 *   variables: {
 *      fetchCouponsListInput: // value for 'fetchCouponsListInput'
 *   },
 * });
 */
export function useFetchCouponsListQuery(baseOptions: Apollo.QueryHookOptions<FetchCouponsListQuery, FetchCouponsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCouponsListQuery, FetchCouponsListQueryVariables>(FetchCouponsListDocument, options);
      }
export function useFetchCouponsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCouponsListQuery, FetchCouponsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCouponsListQuery, FetchCouponsListQueryVariables>(FetchCouponsListDocument, options);
        }
export type FetchCouponsListQueryHookResult = ReturnType<typeof useFetchCouponsListQuery>;
export type FetchCouponsListLazyQueryHookResult = ReturnType<typeof useFetchCouponsListLazyQuery>;
export type FetchCouponsListQueryResult = Apollo.QueryResult<FetchCouponsListQuery, FetchCouponsListQueryVariables>;
export const CreateCouponDocument = gql`
    mutation CreateCoupon($createCouponInput: CreateCouponInput!) {
  createCoupon(createCouponInput: $createCouponInput)
}
    `;
export type CreateCouponMutationFn = Apollo.MutationFunction<CreateCouponMutation, CreateCouponMutationVariables>;

/**
 * __useCreateCouponMutation__
 *
 * To run a mutation, you first call `useCreateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponMutation, { data, loading, error }] = useCreateCouponMutation({
 *   variables: {
 *      createCouponInput: // value for 'createCouponInput'
 *   },
 * });
 */
export function useCreateCouponMutation(baseOptions?: Apollo.MutationHookOptions<CreateCouponMutation, CreateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCouponMutation, CreateCouponMutationVariables>(CreateCouponDocument, options);
      }
export type CreateCouponMutationHookResult = ReturnType<typeof useCreateCouponMutation>;
export type CreateCouponMutationResult = Apollo.MutationResult<CreateCouponMutation>;
export type CreateCouponMutationOptions = Apollo.BaseMutationOptions<CreateCouponMutation, CreateCouponMutationVariables>;
export const FetchProductsDocument = gql`
    query FetchProducts {
  fetchProducts {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchProductsQuery__
 *
 * To run a query within a React component, call `useFetchProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchProductsQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductsQuery, FetchProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductsQuery, FetchProductsQueryVariables>(FetchProductsDocument, options);
      }
export function useFetchProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductsQuery, FetchProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductsQuery, FetchProductsQueryVariables>(FetchProductsDocument, options);
        }
export type FetchProductsQueryHookResult = ReturnType<typeof useFetchProductsQuery>;
export type FetchProductsLazyQueryHookResult = ReturnType<typeof useFetchProductsLazyQuery>;
export type FetchProductsQueryResult = Apollo.QueryResult<FetchProductsQuery, FetchProductsQueryVariables>;
export const DeleteCouponDocument = gql`
    mutation DeleteCoupon($deleteCouponInput: String!) {
  deleteCoupon(deleteCouponInput: $deleteCouponInput)
}
    `;
export type DeleteCouponMutationFn = Apollo.MutationFunction<DeleteCouponMutation, DeleteCouponMutationVariables>;

/**
 * __useDeleteCouponMutation__
 *
 * To run a mutation, you first call `useDeleteCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCouponMutation, { data, loading, error }] = useDeleteCouponMutation({
 *   variables: {
 *      deleteCouponInput: // value for 'deleteCouponInput'
 *   },
 * });
 */
export function useDeleteCouponMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCouponMutation, DeleteCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCouponMutation, DeleteCouponMutationVariables>(DeleteCouponDocument, options);
      }
export type DeleteCouponMutationHookResult = ReturnType<typeof useDeleteCouponMutation>;
export type DeleteCouponMutationResult = Apollo.MutationResult<DeleteCouponMutation>;
export type DeleteCouponMutationOptions = Apollo.BaseMutationOptions<DeleteCouponMutation, DeleteCouponMutationVariables>;
export const UpdateCouponDocument = gql`
    mutation UpdateCoupon($updateCouponInput: UpdateCouponInput!) {
  updateCoupon(updateCouponInput: $updateCouponInput)
}
    `;
export type UpdateCouponMutationFn = Apollo.MutationFunction<UpdateCouponMutation, UpdateCouponMutationVariables>;

/**
 * __useUpdateCouponMutation__
 *
 * To run a mutation, you first call `useUpdateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCouponMutation, { data, loading, error }] = useUpdateCouponMutation({
 *   variables: {
 *      updateCouponInput: // value for 'updateCouponInput'
 *   },
 * });
 */
export function useUpdateCouponMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCouponMutation, UpdateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCouponMutation, UpdateCouponMutationVariables>(UpdateCouponDocument, options);
      }
export type UpdateCouponMutationHookResult = ReturnType<typeof useUpdateCouponMutation>;
export type UpdateCouponMutationResult = Apollo.MutationResult<UpdateCouponMutation>;
export type UpdateCouponMutationOptions = Apollo.BaseMutationOptions<UpdateCouponMutation, UpdateCouponMutationVariables>;
export const FetchActiveRedemptionsDocument = gql`
    query FetchActiveRedemptions($fetchActiveRedemptionsInput: ActiveRedemptionsInput!) {
  fetchActiveRedemptions(
    fetchActiveRedemptionsInput: $fetchActiveRedemptionsInput
  ) {
    data {
      id
      email
      created
      name
      address {
        city
        country
        line1
        line2
        postal_code
        state
      }
      balance
      object
      livemode
    }
    has_more
    next_page
    url
  }
}
    `;

/**
 * __useFetchActiveRedemptionsQuery__
 *
 * To run a query within a React component, call `useFetchActiveRedemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchActiveRedemptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchActiveRedemptionsQuery({
 *   variables: {
 *      fetchActiveRedemptionsInput: // value for 'fetchActiveRedemptionsInput'
 *   },
 * });
 */
export function useFetchActiveRedemptionsQuery(baseOptions: Apollo.QueryHookOptions<FetchActiveRedemptionsQuery, FetchActiveRedemptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchActiveRedemptionsQuery, FetchActiveRedemptionsQueryVariables>(FetchActiveRedemptionsDocument, options);
      }
export function useFetchActiveRedemptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchActiveRedemptionsQuery, FetchActiveRedemptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchActiveRedemptionsQuery, FetchActiveRedemptionsQueryVariables>(FetchActiveRedemptionsDocument, options);
        }
export type FetchActiveRedemptionsQueryHookResult = ReturnType<typeof useFetchActiveRedemptionsQuery>;
export type FetchActiveRedemptionsLazyQueryHookResult = ReturnType<typeof useFetchActiveRedemptionsLazyQuery>;
export type FetchActiveRedemptionsQueryResult = Apollo.QueryResult<FetchActiveRedemptionsQuery, FetchActiveRedemptionsQueryVariables>;
export const FetchProductsByIdsDocument = gql`
    query FetchProductsByIds($fetchProductsByIdInput: ProductsByIdInput!) {
  fetchProductsByIds(fetchProductsByIdInput: $fetchProductsByIdInput) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchProductsByIdsQuery__
 *
 * To run a query within a React component, call `useFetchProductsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductsByIdsQuery({
 *   variables: {
 *      fetchProductsByIdInput: // value for 'fetchProductsByIdInput'
 *   },
 * });
 */
export function useFetchProductsByIdsQuery(baseOptions: Apollo.QueryHookOptions<FetchProductsByIdsQuery, FetchProductsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductsByIdsQuery, FetchProductsByIdsQueryVariables>(FetchProductsByIdsDocument, options);
      }
export function useFetchProductsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductsByIdsQuery, FetchProductsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductsByIdsQuery, FetchProductsByIdsQueryVariables>(FetchProductsByIdsDocument, options);
        }
export type FetchProductsByIdsQueryHookResult = ReturnType<typeof useFetchProductsByIdsQuery>;
export type FetchProductsByIdsLazyQueryHookResult = ReturnType<typeof useFetchProductsByIdsLazyQuery>;
export type FetchProductsByIdsQueryResult = Apollo.QueryResult<FetchProductsByIdsQuery, FetchProductsByIdsQueryVariables>;
export const FetchUserDocument = gql`
    query FetchUser($userId: String!) {
  fetchUser(userId: $userId) {
    createdAt
    email
    emailVerified
    fullName
    id
    showLogo
    isSubscribed {
      customerStripeId
    }
    isTPinAdded
    phoneNumber
    roles {
      createdAt
      id
      role
      updatedAt
    }
    status
    updatedAt
  }
}
    `;

/**
 * __useFetchUserQuery__
 *
 * To run a query within a React component, call `useFetchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUserQuery(baseOptions: Apollo.QueryHookOptions<FetchUserQuery, FetchUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserQuery, FetchUserQueryVariables>(FetchUserDocument, options);
      }
export function useFetchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserQuery, FetchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserQuery, FetchUserQueryVariables>(FetchUserDocument, options);
        }
export type FetchUserQueryHookResult = ReturnType<typeof useFetchUserQuery>;
export type FetchUserLazyQueryHookResult = ReturnType<typeof useFetchUserLazyQuery>;
export type FetchUserQueryResult = Apollo.QueryResult<FetchUserQuery, FetchUserQueryVariables>;
export const FetchContactsByUserIdDocument = gql`
    query FetchContactsByUserId($userId: String!) {
  fetchContactsByUserId(userId: $userId) {
    createdAt
    id
    name
    nickName
    phoneNumber
    phoneType
    priority
    updatedAt
    email
    status
    declinedCount
  }
}
    `;

/**
 * __useFetchContactsByUserIdQuery__
 *
 * To run a query within a React component, call `useFetchContactsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchContactsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchContactsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchContactsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<FetchContactsByUserIdQuery, FetchContactsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchContactsByUserIdQuery, FetchContactsByUserIdQueryVariables>(FetchContactsByUserIdDocument, options);
      }
export function useFetchContactsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchContactsByUserIdQuery, FetchContactsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchContactsByUserIdQuery, FetchContactsByUserIdQueryVariables>(FetchContactsByUserIdDocument, options);
        }
export type FetchContactsByUserIdQueryHookResult = ReturnType<typeof useFetchContactsByUserIdQuery>;
export type FetchContactsByUserIdLazyQueryHookResult = ReturnType<typeof useFetchContactsByUserIdLazyQuery>;
export type FetchContactsByUserIdQueryResult = Apollo.QueryResult<FetchContactsByUserIdQuery, FetchContactsByUserIdQueryVariables>;
export const FetchCustomerInvoicesDocument = gql`
    query FetchCustomerInvoices($customerInvoiceInput: InvoiceInput!) {
  fetchCustomerInvoices(customerInvoiceInput: $customerInvoiceInput) {
    data {
      account_country
      account_name
      amount_due
      amount_paid
      amount_remaining
      attempt_count
      billing_reason
      charge {
        amount
        created
        description
        failure_code
        failure_message
        id
        object
        paid
        receipt_number
        receipt_url
        status
      }
      created
      currency
      customer
      customer_email
      hosted_invoice_url
      id
      invoice_pdf
      number
      object
      paid
      period_end
      period_start
      status
      subtotal
      subtotal_excluding_tax
      total
      total_discount_amounts {
        amount
        discount
      }
    }
    has_more
    url
  }
}
    `;

/**
 * __useFetchCustomerInvoicesQuery__
 *
 * To run a query within a React component, call `useFetchCustomerInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerInvoicesQuery({
 *   variables: {
 *      customerInvoiceInput: // value for 'customerInvoiceInput'
 *   },
 * });
 */
export function useFetchCustomerInvoicesQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerInvoicesQuery, FetchCustomerInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerInvoicesQuery, FetchCustomerInvoicesQueryVariables>(FetchCustomerInvoicesDocument, options);
      }
export function useFetchCustomerInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerInvoicesQuery, FetchCustomerInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerInvoicesQuery, FetchCustomerInvoicesQueryVariables>(FetchCustomerInvoicesDocument, options);
        }
export type FetchCustomerInvoicesQueryHookResult = ReturnType<typeof useFetchCustomerInvoicesQuery>;
export type FetchCustomerInvoicesLazyQueryHookResult = ReturnType<typeof useFetchCustomerInvoicesLazyQuery>;
export type FetchCustomerInvoicesQueryResult = Apollo.QueryResult<FetchCustomerInvoicesQuery, FetchCustomerInvoicesQueryVariables>;
export const FetchBillingDetailsDocument = gql`
    query fetchBillingDetails($fetchCardDetailsInput: String!) {
  fetchCardDetails(fetchCardDetailsInput: $fetchCardDetailsInput) {
    address_line1
    address_line2
    address_state
    address_zip
    address_city
    address_country
    customer_name
    name
    exp_month
    exp_year
    last4
    brand
  }
}
    `;

/**
 * __useFetchBillingDetailsQuery__
 *
 * To run a query within a React component, call `useFetchBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBillingDetailsQuery({
 *   variables: {
 *      fetchCardDetailsInput: // value for 'fetchCardDetailsInput'
 *   },
 * });
 */
export function useFetchBillingDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchBillingDetailsQuery, FetchBillingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBillingDetailsQuery, FetchBillingDetailsQueryVariables>(FetchBillingDetailsDocument, options);
      }
export function useFetchBillingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBillingDetailsQuery, FetchBillingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBillingDetailsQuery, FetchBillingDetailsQueryVariables>(FetchBillingDetailsDocument, options);
        }
export type FetchBillingDetailsQueryHookResult = ReturnType<typeof useFetchBillingDetailsQuery>;
export type FetchBillingDetailsLazyQueryHookResult = ReturnType<typeof useFetchBillingDetailsLazyQuery>;
export type FetchBillingDetailsQueryResult = Apollo.QueryResult<FetchBillingDetailsQuery, FetchBillingDetailsQueryVariables>;
export const SuperAdminUpdateAdminDocument = gql`
    mutation SuperAdminUpdateAdmin($superAdminUpdateAdminInput: SuperAdminUpdateAdminInput!) {
  superAdminUpdateAdmin(superAdminUpdateAdminInput: $superAdminUpdateAdminInput) {
    fullName
  }
}
    `;
export type SuperAdminUpdateAdminMutationFn = Apollo.MutationFunction<SuperAdminUpdateAdminMutation, SuperAdminUpdateAdminMutationVariables>;

/**
 * __useSuperAdminUpdateAdminMutation__
 *
 * To run a mutation, you first call `useSuperAdminUpdateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminUpdateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superAdminUpdateAdminMutation, { data, loading, error }] = useSuperAdminUpdateAdminMutation({
 *   variables: {
 *      superAdminUpdateAdminInput: // value for 'superAdminUpdateAdminInput'
 *   },
 * });
 */
export function useSuperAdminUpdateAdminMutation(baseOptions?: Apollo.MutationHookOptions<SuperAdminUpdateAdminMutation, SuperAdminUpdateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperAdminUpdateAdminMutation, SuperAdminUpdateAdminMutationVariables>(SuperAdminUpdateAdminDocument, options);
      }
export type SuperAdminUpdateAdminMutationHookResult = ReturnType<typeof useSuperAdminUpdateAdminMutation>;
export type SuperAdminUpdateAdminMutationResult = Apollo.MutationResult<SuperAdminUpdateAdminMutation>;
export type SuperAdminUpdateAdminMutationOptions = Apollo.BaseMutationOptions<SuperAdminUpdateAdminMutation, SuperAdminUpdateAdminMutationVariables>;
export const FetchUserUsageDetailsDocument = gql`
    query FetchUserUsageDetails($userId: String!) {
  fetchUserUsageDetails(userId: $userId) {
    currentMonthUsage
    overAllUsage
  }
}
    `;

/**
 * __useFetchUserUsageDetailsQuery__
 *
 * To run a query within a React component, call `useFetchUserUsageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserUsageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserUsageDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUserUsageDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchUserUsageDetailsQuery, FetchUserUsageDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserUsageDetailsQuery, FetchUserUsageDetailsQueryVariables>(FetchUserUsageDetailsDocument, options);
      }
export function useFetchUserUsageDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserUsageDetailsQuery, FetchUserUsageDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserUsageDetailsQuery, FetchUserUsageDetailsQueryVariables>(FetchUserUsageDetailsDocument, options);
        }
export type FetchUserUsageDetailsQueryHookResult = ReturnType<typeof useFetchUserUsageDetailsQuery>;
export type FetchUserUsageDetailsLazyQueryHookResult = ReturnType<typeof useFetchUserUsageDetailsLazyQuery>;
export type FetchUserUsageDetailsQueryResult = Apollo.QueryResult<FetchUserUsageDetailsQuery, FetchUserUsageDetailsQueryVariables>;
export const GetSubscriptionDetailDocument = gql`
    query GetSubscriptionDetail($customerStripeId: String!) {
  getSubscriptionDetail(customerStripeId: $customerStripeId) {
    data {
      application
      application_fee_percent
      automatic_tax {
        enabled
      }
      billing_cycle_anchor
      billing_thresholds {
        amount_gte
        reset_billing_cycle_anchor
      }
      cancel_at
      cancel_at_period_end
      canceled_at
      cancellation_details {
        comment
        feedback
        reason
      }
      created
      default_payment_method
      default_source
      default_tax_rates {
        active
        country
        created
        description
        display_name
        effective_percentage
        id
        inclusive
        jurisdiction
        livemode
        object
        percentage
        state
      }
      description
      ended_at
      id
      items {
        data {
          plan {
            nickname
            amount
            product
            metadata
            interval
            id
            created
          }
          created
          id
          object
          plan {
            active
            aggregate_usage
            amount
            amount_decimal
            billing_scheme
            created
            currency
            id
            interval
            metadata
            nickname
            object
            product
            tiers_mode
            transform_usage {
              divide_by
              round
            }
            trial_period_days
            usage_type
          }
          quantity
          subscription
        }
      }
      latest_invoice
      livemode
      next_pending_invoice_item_invoice
      object
      on_behalf_of
      pause_collection {
        behavior
        resumes_at
      }
      pending_invoice_item_interval {
        interval
      }
      schedule
      start_date
      status
      transfer_data {
        amount_percent
        destination
      }
      trial_end
      trial_settings {
        end_behavior {
          missing_payment_method
        }
      }
      trial_start
      metadata
      current_period_end
    }
  }
}
    `;

/**
 * __useGetSubscriptionDetailQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionDetailQuery({
 *   variables: {
 *      customerStripeId: // value for 'customerStripeId'
 *   },
 * });
 */
export function useGetSubscriptionDetailQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionDetailQuery, GetSubscriptionDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionDetailQuery, GetSubscriptionDetailQueryVariables>(GetSubscriptionDetailDocument, options);
      }
export function useGetSubscriptionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionDetailQuery, GetSubscriptionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionDetailQuery, GetSubscriptionDetailQueryVariables>(GetSubscriptionDetailDocument, options);
        }
export type GetSubscriptionDetailQueryHookResult = ReturnType<typeof useGetSubscriptionDetailQuery>;
export type GetSubscriptionDetailLazyQueryHookResult = ReturnType<typeof useGetSubscriptionDetailLazyQuery>;
export type GetSubscriptionDetailQueryResult = Apollo.QueryResult<GetSubscriptionDetailQuery, GetSubscriptionDetailQueryVariables>;
export const FetchAllContactsDocument = gql`
    query FetchAllContacts {
  fetchAllContacts {
    id
    createdAt
    updatedAt
    phoneNumber
    priority
    nickName
    name
    phoneType
  }
}
    `;

/**
 * __useFetchAllContactsQuery__
 *
 * To run a query within a React component, call `useFetchAllContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllContactsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllContactsQuery, FetchAllContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllContactsQuery, FetchAllContactsQueryVariables>(FetchAllContactsDocument, options);
      }
export function useFetchAllContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllContactsQuery, FetchAllContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllContactsQuery, FetchAllContactsQueryVariables>(FetchAllContactsDocument, options);
        }
export type FetchAllContactsQueryHookResult = ReturnType<typeof useFetchAllContactsQuery>;
export type FetchAllContactsLazyQueryHookResult = ReturnType<typeof useFetchAllContactsLazyQuery>;
export type FetchAllContactsQueryResult = Apollo.QueryResult<FetchAllContactsQuery, FetchAllContactsQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($deleteUserInput: DeleteUserInput!) {
  deleteUser(deleteUserInput: $deleteUserInput)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      deleteUserInput: // value for 'deleteUserInput'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ResendOptInLinkDocument = gql`
    mutation ResendOptInLink($contactOptInInput: ContactOptInLinkInput!) {
  resendOptInLink(contactOptInInput: $contactOptInInput)
}
    `;
export type ResendOptInLinkMutationFn = Apollo.MutationFunction<ResendOptInLinkMutation, ResendOptInLinkMutationVariables>;

/**
 * __useResendOptInLinkMutation__
 *
 * To run a mutation, you first call `useResendOptInLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOptInLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOptInLinkMutation, { data, loading, error }] = useResendOptInLinkMutation({
 *   variables: {
 *      contactOptInInput: // value for 'contactOptInInput'
 *   },
 * });
 */
export function useResendOptInLinkMutation(baseOptions?: Apollo.MutationHookOptions<ResendOptInLinkMutation, ResendOptInLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendOptInLinkMutation, ResendOptInLinkMutationVariables>(ResendOptInLinkDocument, options);
      }
export type ResendOptInLinkMutationHookResult = ReturnType<typeof useResendOptInLinkMutation>;
export type ResendOptInLinkMutationResult = Apollo.MutationResult<ResendOptInLinkMutation>;
export type ResendOptInLinkMutationOptions = Apollo.BaseMutationOptions<ResendOptInLinkMutation, ResendOptInLinkMutationVariables>;
export const FetchUserByEmailDocument = gql`
    query FetchUserByEmail($fetchUserByEmailInput: FetchUserByEmailInput!) {
  fetchUserByEmail(fetchUserByEmailInput: $fetchUserByEmailInput) {
    id
  }
}
    `;

/**
 * __useFetchUserByEmailQuery__
 *
 * To run a query within a React component, call `useFetchUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserByEmailQuery({
 *   variables: {
 *      fetchUserByEmailInput: // value for 'fetchUserByEmailInput'
 *   },
 * });
 */
export function useFetchUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<FetchUserByEmailQuery, FetchUserByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserByEmailQuery, FetchUserByEmailQueryVariables>(FetchUserByEmailDocument, options);
      }
export function useFetchUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserByEmailQuery, FetchUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserByEmailQuery, FetchUserByEmailQueryVariables>(FetchUserByEmailDocument, options);
        }
export type FetchUserByEmailQueryHookResult = ReturnType<typeof useFetchUserByEmailQuery>;
export type FetchUserByEmailLazyQueryHookResult = ReturnType<typeof useFetchUserByEmailLazyQuery>;
export type FetchUserByEmailQueryResult = Apollo.QueryResult<FetchUserByEmailQuery, FetchUserByEmailQueryVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($inviteUserInput: InviteUserInput!) {
  inviteUser(InviteUserInput: $inviteUserInput)
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      inviteUserInput: // value for 'inviteUserInput'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const SendOtpDocument = gql`
    mutation SendOtp($sendOtpInput: SendOtpInput!) {
  sendOtp(sendOtpInput: $sendOtpInput) {
    code
    sendOtp
  }
}
    `;
export type SendOtpMutationFn = Apollo.MutationFunction<SendOtpMutation, SendOtpMutationVariables>;

/**
 * __useSendOtpMutation__
 *
 * To run a mutation, you first call `useSendOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOtpMutation, { data, loading, error }] = useSendOtpMutation({
 *   variables: {
 *      sendOtpInput: // value for 'sendOtpInput'
 *   },
 * });
 */
export function useSendOtpMutation(baseOptions?: Apollo.MutationHookOptions<SendOtpMutation, SendOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOtpMutation, SendOtpMutationVariables>(SendOtpDocument, options);
      }
export type SendOtpMutationHookResult = ReturnType<typeof useSendOtpMutation>;
export type SendOtpMutationResult = Apollo.MutationResult<SendOtpMutation>;
export type SendOtpMutationOptions = Apollo.BaseMutationOptions<SendOtpMutation, SendOtpMutationVariables>;
export const VerifyOtpDocument = gql`
    mutation VerifyOtp($verifyOtpInput: OtpVerifyInput!) {
  verifyOtp(verifyOtpInput: $verifyOtpInput) {
    phoneNumber
  }
}
    `;
export type VerifyOtpMutationFn = Apollo.MutationFunction<VerifyOtpMutation, VerifyOtpMutationVariables>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      verifyOtpInput: // value for 'verifyOtpInput'
 *   },
 * });
 */
export function useVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOtpMutation, VerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOtpMutation, VerifyOtpMutationVariables>(VerifyOtpDocument, options);
      }
export type VerifyOtpMutationHookResult = ReturnType<typeof useVerifyOtpMutation>;
export type VerifyOtpMutationResult = Apollo.MutationResult<VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const AddSecurityPinDocument = gql`
    mutation AddSecurityPin($addOrUpdateSecurityPinInput: AddOrUpdateSecurityPin!) {
  addSecurityPin(addOrUpdateSecurityPinInput: $addOrUpdateSecurityPinInput)
}
    `;
export type AddSecurityPinMutationFn = Apollo.MutationFunction<AddSecurityPinMutation, AddSecurityPinMutationVariables>;

/**
 * __useAddSecurityPinMutation__
 *
 * To run a mutation, you first call `useAddSecurityPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSecurityPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSecurityPinMutation, { data, loading, error }] = useAddSecurityPinMutation({
 *   variables: {
 *      addOrUpdateSecurityPinInput: // value for 'addOrUpdateSecurityPinInput'
 *   },
 * });
 */
export function useAddSecurityPinMutation(baseOptions?: Apollo.MutationHookOptions<AddSecurityPinMutation, AddSecurityPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSecurityPinMutation, AddSecurityPinMutationVariables>(AddSecurityPinDocument, options);
      }
export type AddSecurityPinMutationHookResult = ReturnType<typeof useAddSecurityPinMutation>;
export type AddSecurityPinMutationResult = Apollo.MutationResult<AddSecurityPinMutation>;
export type AddSecurityPinMutationOptions = Apollo.BaseMutationOptions<AddSecurityPinMutation, AddSecurityPinMutationVariables>;
export const FetchPlanDocument = gql`
    query FetchPlan {
  fetchPlan {
    data {
      active
      aggregate_usage
      amount
      amount_decimal
      billing_scheme
      created
      currency
      id
      interval
      metadata
      nickname
      object
      product
      tiers {
        flat_amount
        flat_amount_decimal
        unit_amount
        unit_amount_decimal
        up_to
      }
      tiers_mode
      transform_usage {
        divide_by
        round
      }
      trial_period_days
      usage_type
    }
  }
}
    `;

/**
 * __useFetchPlanQuery__
 *
 * To run a query within a React component, call `useFetchPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPlanQuery(baseOptions?: Apollo.QueryHookOptions<FetchPlanQuery, FetchPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlanQuery, FetchPlanQueryVariables>(FetchPlanDocument, options);
      }
export function useFetchPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlanQuery, FetchPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlanQuery, FetchPlanQueryVariables>(FetchPlanDocument, options);
        }
export type FetchPlanQueryHookResult = ReturnType<typeof useFetchPlanQuery>;
export type FetchPlanLazyQueryHookResult = ReturnType<typeof useFetchPlanLazyQuery>;
export type FetchPlanQueryResult = Apollo.QueryResult<FetchPlanQuery, FetchPlanQueryVariables>;
export const RetrieveCouponDocument = gql`
    query RetrieveCoupon($retrieveCouponInput: String!) {
  retrieveCoupon(retrieveCouponInput: $retrieveCouponInput) {
    amountOff
    name
    percentOff
    products
  }
}
    `;

/**
 * __useRetrieveCouponQuery__
 *
 * To run a query within a React component, call `useRetrieveCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveCouponQuery({
 *   variables: {
 *      retrieveCouponInput: // value for 'retrieveCouponInput'
 *   },
 * });
 */
export function useRetrieveCouponQuery(baseOptions: Apollo.QueryHookOptions<RetrieveCouponQuery, RetrieveCouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveCouponQuery, RetrieveCouponQueryVariables>(RetrieveCouponDocument, options);
      }
export function useRetrieveCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveCouponQuery, RetrieveCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveCouponQuery, RetrieveCouponQueryVariables>(RetrieveCouponDocument, options);
        }
export type RetrieveCouponQueryHookResult = ReturnType<typeof useRetrieveCouponQuery>;
export type RetrieveCouponLazyQueryHookResult = ReturnType<typeof useRetrieveCouponLazyQuery>;
export type RetrieveCouponQueryResult = Apollo.QueryResult<RetrieveCouponQuery, RetrieveCouponQueryVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($createSubscriptionInput: CreateSubscriptionInput!) {
  createSubscription(createSubscriptionInput: $createSubscriptionInput) {
    customerStripeId
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      createSubscriptionInput: // value for 'createSubscriptionInput'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const UpdateNameDocument = gql`
    mutation UpdateName($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    fullName
  }
}
    `;
export type UpdateNameMutationFn = Apollo.MutationFunction<UpdateNameMutation, UpdateNameMutationVariables>;

/**
 * __useUpdateNameMutation__
 *
 * To run a mutation, you first call `useUpdateNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNameMutation, { data, loading, error }] = useUpdateNameMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUpdateNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNameMutation, UpdateNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNameMutation, UpdateNameMutationVariables>(UpdateNameDocument, options);
      }
export type UpdateNameMutationHookResult = ReturnType<typeof useUpdateNameMutation>;
export type UpdateNameMutationResult = Apollo.MutationResult<UpdateNameMutation>;
export type UpdateNameMutationOptions = Apollo.BaseMutationOptions<UpdateNameMutation, UpdateNameMutationVariables>;
export const UpdateEmailDocument = gql`
    mutation UpdateEmail($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    email
  }
}
    `;
export type UpdateEmailMutationFn = Apollo.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUpdateEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, options);
      }
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation UpdateUserPassword($updateUserPasswordInput: UpdateUserPasswordInput!) {
  updateUserPassword(updateUserPasswordInput: $updateUserPasswordInput) {
    id
  }
}
    `;
export type UpdateUserPasswordMutationFn = Apollo.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      updateUserPasswordInput: // value for 'updateUserPasswordInput'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const UpdatePhoneNumberDocument = gql`
    mutation UpdatePhoneNumber($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    phoneNumber
  }
}
    `;
export type UpdatePhoneNumberMutationFn = Apollo.MutationFunction<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;

/**
 * __useUpdatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneNumberMutation, { data, loading, error }] = useUpdatePhoneNumberMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUpdatePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>(UpdatePhoneNumberDocument, options);
      }
export type UpdatePhoneNumberMutationHookResult = ReturnType<typeof useUpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationResult = Apollo.MutationResult<UpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;
export const DeactivateUserAccountDocument = gql`
    mutation DeactivateUserAccount {
  deactivateUserAccount {
    status
  }
}
    `;
export type DeactivateUserAccountMutationFn = Apollo.MutationFunction<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>;

/**
 * __useDeactivateUserAccountMutation__
 *
 * To run a mutation, you first call `useDeactivateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserAccountMutation, { data, loading, error }] = useDeactivateUserAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeactivateUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>(DeactivateUserAccountDocument, options);
      }
export type DeactivateUserAccountMutationHookResult = ReturnType<typeof useDeactivateUserAccountMutation>;
export type DeactivateUserAccountMutationResult = Apollo.MutationResult<DeactivateUserAccountMutation>;
export type DeactivateUserAccountMutationOptions = Apollo.BaseMutationOptions<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>;
export const AdminUpdateCustomerEmailDocument = gql`
    mutation AdminUpdateCustomerEmail($userId: String!, $email: String!) {
  adminUpdateCustomerEmail(userId: $userId, email: $email) {
    id
    email
  }
}
    `;
export type AdminUpdateCustomerEmailMutationFn = Apollo.MutationFunction<AdminUpdateCustomerEmailMutation, AdminUpdateCustomerEmailMutationVariables>;

/**
 * __useAdminUpdateCustomerEmailMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCustomerEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCustomerEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCustomerEmailMutation, { data, loading, error }] = useAdminUpdateCustomerEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAdminUpdateCustomerEmailMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCustomerEmailMutation, AdminUpdateCustomerEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCustomerEmailMutation, AdminUpdateCustomerEmailMutationVariables>(AdminUpdateCustomerEmailDocument, options);
      }
export type AdminUpdateCustomerEmailMutationHookResult = ReturnType<typeof useAdminUpdateCustomerEmailMutation>;
export type AdminUpdateCustomerEmailMutationResult = Apollo.MutationResult<AdminUpdateCustomerEmailMutation>;
export type AdminUpdateCustomerEmailMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCustomerEmailMutation, AdminUpdateCustomerEmailMutationVariables>;
export const ReferralsByAssigneeDocument = gql`
    query ReferralsByAssignee($input: ReferralsByAssigneeInput!) {
  referralsByAssignee(input: $input) {
    pagination {
      hasMore
      limit
      page
      totalCount
      totalPages
    }
    referrals {
      id
      promoCode
      assigneeUserId
      referredUserId
      referrerUserId
      rootPromoCodeId
      createdAt
      updatedAt
      directChildCount
      totalDescendantCount
      freeMonthsAtApply
      assigneeUser {
        id
        fullName
        email
      }
      referredUser {
        id
        fullName
        email
      }
      referrerUser {
        id
        fullName
        email
      }
    }
  }
}
    `;

/**
 * __useReferralsByAssigneeQuery__
 *
 * To run a query within a React component, call `useReferralsByAssigneeQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralsByAssigneeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralsByAssigneeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReferralsByAssigneeQuery(baseOptions: Apollo.QueryHookOptions<ReferralsByAssigneeQuery, ReferralsByAssigneeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferralsByAssigneeQuery, ReferralsByAssigneeQueryVariables>(ReferralsByAssigneeDocument, options);
      }
export function useReferralsByAssigneeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferralsByAssigneeQuery, ReferralsByAssigneeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferralsByAssigneeQuery, ReferralsByAssigneeQueryVariables>(ReferralsByAssigneeDocument, options);
        }
export type ReferralsByAssigneeQueryHookResult = ReturnType<typeof useReferralsByAssigneeQuery>;
export type ReferralsByAssigneeLazyQueryHookResult = ReturnType<typeof useReferralsByAssigneeLazyQuery>;
export type ReferralsByAssigneeQueryResult = Apollo.QueryResult<ReferralsByAssigneeQuery, ReferralsByAssigneeQueryVariables>;
export const FetchSocialSourcesDocument = gql`
    query FetchSocialSources($input: PaginationInput!) {
  fetchSocialSources(input: $input) {
    pagination {
      page
      totalCount
      limit
      totalPages
    }
    socialSources {
      id
      name
      totalUsersReached
    }
  }
}
    `;

/**
 * __useFetchSocialSourcesQuery__
 *
 * To run a query within a React component, call `useFetchSocialSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSocialSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSocialSourcesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchSocialSourcesQuery(baseOptions: Apollo.QueryHookOptions<FetchSocialSourcesQuery, FetchSocialSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSocialSourcesQuery, FetchSocialSourcesQueryVariables>(FetchSocialSourcesDocument, options);
      }
export function useFetchSocialSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSocialSourcesQuery, FetchSocialSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSocialSourcesQuery, FetchSocialSourcesQueryVariables>(FetchSocialSourcesDocument, options);
        }
export type FetchSocialSourcesQueryHookResult = ReturnType<typeof useFetchSocialSourcesQuery>;
export type FetchSocialSourcesLazyQueryHookResult = ReturnType<typeof useFetchSocialSourcesLazyQuery>;
export type FetchSocialSourcesQueryResult = Apollo.QueryResult<FetchSocialSourcesQuery, FetchSocialSourcesQueryVariables>;
export const CreateSocialSourceDocument = gql`
    mutation CreateSocialSource($createSocialSourceInput: CreateSocialSourceInput!) {
  createSocialSource(createSocialSourceInput: $createSocialSourceInput) {
    name
  }
}
    `;
export type CreateSocialSourceMutationFn = Apollo.MutationFunction<CreateSocialSourceMutation, CreateSocialSourceMutationVariables>;

/**
 * __useCreateSocialSourceMutation__
 *
 * To run a mutation, you first call `useCreateSocialSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSocialSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSocialSourceMutation, { data, loading, error }] = useCreateSocialSourceMutation({
 *   variables: {
 *      createSocialSourceInput: // value for 'createSocialSourceInput'
 *   },
 * });
 */
export function useCreateSocialSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateSocialSourceMutation, CreateSocialSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSocialSourceMutation, CreateSocialSourceMutationVariables>(CreateSocialSourceDocument, options);
      }
export type CreateSocialSourceMutationHookResult = ReturnType<typeof useCreateSocialSourceMutation>;
export type CreateSocialSourceMutationResult = Apollo.MutationResult<CreateSocialSourceMutation>;
export type CreateSocialSourceMutationOptions = Apollo.BaseMutationOptions<CreateSocialSourceMutation, CreateSocialSourceMutationVariables>;
export const RemoveSocialSourceDocument = gql`
    mutation RemoveSocialSource($input: RemoveSocialSourceInput!) {
  removeSocialSource(input: $input)
}
    `;
export type RemoveSocialSourceMutationFn = Apollo.MutationFunction<RemoveSocialSourceMutation, RemoveSocialSourceMutationVariables>;

/**
 * __useRemoveSocialSourceMutation__
 *
 * To run a mutation, you first call `useRemoveSocialSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSocialSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSocialSourceMutation, { data, loading, error }] = useRemoveSocialSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSocialSourceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSocialSourceMutation, RemoveSocialSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSocialSourceMutation, RemoveSocialSourceMutationVariables>(RemoveSocialSourceDocument, options);
      }
export type RemoveSocialSourceMutationHookResult = ReturnType<typeof useRemoveSocialSourceMutation>;
export type RemoveSocialSourceMutationResult = Apollo.MutationResult<RemoveSocialSourceMutation>;
export type RemoveSocialSourceMutationOptions = Apollo.BaseMutationOptions<RemoveSocialSourceMutation, RemoveSocialSourceMutationVariables>;
export const UpdateSocialSourceDocument = gql`
    mutation UpdateSocialSource($updateSocialSourceInput: UpdateSocialSourceInput!) {
  updateSocialSource(updateSocialSourceInput: $updateSocialSourceInput) {
    id
    name
  }
}
    `;
export type UpdateSocialSourceMutationFn = Apollo.MutationFunction<UpdateSocialSourceMutation, UpdateSocialSourceMutationVariables>;

/**
 * __useUpdateSocialSourceMutation__
 *
 * To run a mutation, you first call `useUpdateSocialSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialSourceMutation, { data, loading, error }] = useUpdateSocialSourceMutation({
 *   variables: {
 *      updateSocialSourceInput: // value for 'updateSocialSourceInput'
 *   },
 * });
 */
export function useUpdateSocialSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialSourceMutation, UpdateSocialSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialSourceMutation, UpdateSocialSourceMutationVariables>(UpdateSocialSourceDocument, options);
      }
export type UpdateSocialSourceMutationHookResult = ReturnType<typeof useUpdateSocialSourceMutation>;
export type UpdateSocialSourceMutationResult = Apollo.MutationResult<UpdateSocialSourceMutation>;
export type UpdateSocialSourceMutationOptions = Apollo.BaseMutationOptions<UpdateSocialSourceMutation, UpdateSocialSourceMutationVariables>;
export const FetchFreePlanDocument = gql`
    query FetchFreePlan {
  fetchFreePlan {
    id
    nickname
    amount
    trial_period_days
  }
}
    `;

/**
 * __useFetchFreePlanQuery__
 *
 * To run a query within a React component, call `useFetchFreePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFreePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFreePlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchFreePlanQuery(baseOptions?: Apollo.QueryHookOptions<FetchFreePlanQuery, FetchFreePlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFreePlanQuery, FetchFreePlanQueryVariables>(FetchFreePlanDocument, options);
      }
export function useFetchFreePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFreePlanQuery, FetchFreePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFreePlanQuery, FetchFreePlanQueryVariables>(FetchFreePlanDocument, options);
        }
export type FetchFreePlanQueryHookResult = ReturnType<typeof useFetchFreePlanQuery>;
export type FetchFreePlanLazyQueryHookResult = ReturnType<typeof useFetchFreePlanLazyQuery>;
export type FetchFreePlanQueryResult = Apollo.QueryResult<FetchFreePlanQuery, FetchFreePlanQueryVariables>;
export const UpdateFreePlanDocument = gql`
    mutation UpdateFreePlan($updatePlanInput: UpdatePlanInput!) {
  updateFreePlan(updatePlanInput: $updatePlanInput) {
    id
    trial_period_days
  }
}
    `;
export type UpdateFreePlanMutationFn = Apollo.MutationFunction<UpdateFreePlanMutation, UpdateFreePlanMutationVariables>;

/**
 * __useUpdateFreePlanMutation__
 *
 * To run a mutation, you first call `useUpdateFreePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFreePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFreePlanMutation, { data, loading, error }] = useUpdateFreePlanMutation({
 *   variables: {
 *      updatePlanInput: // value for 'updatePlanInput'
 *   },
 * });
 */
export function useUpdateFreePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFreePlanMutation, UpdateFreePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFreePlanMutation, UpdateFreePlanMutationVariables>(UpdateFreePlanDocument, options);
      }
export type UpdateFreePlanMutationHookResult = ReturnType<typeof useUpdateFreePlanMutation>;
export type UpdateFreePlanMutationResult = Apollo.MutationResult<UpdateFreePlanMutation>;
export type UpdateFreePlanMutationOptions = Apollo.BaseMutationOptions<UpdateFreePlanMutation, UpdateFreePlanMutationVariables>;
export const UpdateUserStatusFromAdminDocument = gql`
    mutation UpdateUserStatusFromAdmin($status: Float!, $userId: String!) {
  updateUserStatusFromAdmin(status: $status, userId: $userId) {
    createdAt
    email
    emailVerified
    fullName
    id
    isSubscribed {
      customerStripeId
    }
    isTPinAdded
    phoneNumber
    roles {
      createdAt
      id
      role
      updatedAt
    }
    status
    updatedAt
  }
}
    `;
export type UpdateUserStatusFromAdminMutationFn = Apollo.MutationFunction<UpdateUserStatusFromAdminMutation, UpdateUserStatusFromAdminMutationVariables>;

/**
 * __useUpdateUserStatusFromAdminMutation__
 *
 * To run a mutation, you first call `useUpdateUserStatusFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserStatusFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserStatusFromAdminMutation, { data, loading, error }] = useUpdateUserStatusFromAdminMutation({
 *   variables: {
 *      status: // value for 'status'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserStatusFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserStatusFromAdminMutation, UpdateUserStatusFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserStatusFromAdminMutation, UpdateUserStatusFromAdminMutationVariables>(UpdateUserStatusFromAdminDocument, options);
      }
export type UpdateUserStatusFromAdminMutationHookResult = ReturnType<typeof useUpdateUserStatusFromAdminMutation>;
export type UpdateUserStatusFromAdminMutationResult = Apollo.MutationResult<UpdateUserStatusFromAdminMutation>;
export type UpdateUserStatusFromAdminMutationOptions = Apollo.BaseMutationOptions<UpdateUserStatusFromAdminMutation, UpdateUserStatusFromAdminMutationVariables>;